<template>
  <v-container grid-list-sm>
    <v-toolbar class="highlight secondary--text pa-2">
      <v-toolbar-title>Amaala Daily Digest</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-text-field light label="From Date" style="margin: 5px;" v-model="fromDate" :disabled="loading || exportLoading"></v-text-field>
        <v-text-field light label="To Date" style="margin: 5px;" v-model="toDate" :disabled="loading || exportLoading"></v-text-field>
        <v-btn flat light @click="generateReport" :loading="loading" :disabled="exportLoading">Generate Report</v-btn>
        <v-btn flat light @click="exportPptx" :disabled="loading || !reportExists" :loading="exportLoading">Export PPTX</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    
    <br/>
    <div class="highlight secondary--text pa-3" v-if="atLeastOneStory || atLeastOneArticle">
      <div class="newsCoverageHeader title" style="display: flex; align-items: center"><v-icon color="secondary" class="mr-2">fas fa-newspaper</v-icon><div style="text-decoration: underline">News Coverage:</div></div>

      <div class="newsCoverage pt-2 mb-3" v-if="globalPoliticsStories.length > 0 || saudiPoliticsStories.length > 0 || globalPoliticsArticles.length > 0 || saudiPoliticsArticles.length > 0">
        <div class="newsCoverageTopicHeader">
          <div class="subtitle-1 newsCoverageTopicHeaderTitle">- GEO-POLITICS:</div>
          <div class="newsCoverageTopicHeaderBtn">
            <v-btn text flat icon @click="deleteTopicConfirmation = true; selectedTopic = 'Politics'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
          </div>
        </div>
        <div class="newsCoverageSection" v-if="globalPoliticsStories.length > 0 || saudiPoliticsStories.length > 0">
          <div class="newsCoverageTopicHeader">
            <div class="subtitle-2 newsCoverageTopicHeaderTitle">- Stories:</div>
            <div class="newsCoverageTopicHeaderBtn">
              <v-btn text flat icon @click="deleteTopicStoriesConfirmation = true; selectedTopic = 'Politics'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
            </div>
          </div>
          <div class="newsCoverageSectionStories">
            <div v-if="globalPoliticsStories.length > 0" :class="saudiPoliticsStories.length > 0 ? 'mb-2' : ''">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- GLOBAL:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicGlobalStoriesConfirmation = true; selectedTopic = 'Politics'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(story, index) in globalPoliticsStories" :key="index">
                <div class="newsCoverageSectionStoryContainer">
                  <div class="newsCoverageSectionStory">
                    <v-radio-group light v-model="globalPoliticsStoriesSelection[index]" column class="mt-0">
                      <v-radio :value="story.title + '.'" color="secondary">
                        <div slot="label" class="secondary--text body-2">{{story.title + '.'}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(story.articleCount) + ' articles'}}</div>
                      <div>{{formatNumber(story.domainCount) + ' sources'}}</div>
                      <div>{{formatNumber(story.facebookComments) + ' Facebook comments'}}</div>
                      <div>{{formatNumber(story.facebookReactions) + ' Facebook reactions'}}</div>
                      <div>{{formatNumber(story.facebookShares) + ' Facebook shares'}}</div>
                      <div>{{formatNumber(story.tweetCount) + ' tweets'}}</div>
                      <div>{{formatNumber(story.impressionCount) + ' impressions'}}</div>
                      <div>{{formatNumber(story.userCount) + ' users'}}</div>
                    </div>
                    <div class="newsCoverageSectionStoryArticles" v-if="globalPoliticsStoriesDisplay[index]">
                      <div v-for="(article, index1) in story.articles" class="newsCoverageSectionStoryArticle">
                        <div class="mb-0">
                          <v-radio-group light v-model="globalPoliticsStoriesSelection[index]" column class="mt-0">
                            <v-radio :value="article.title" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article.title}}</div>
                            </v-radio>
                            <v-radio :value="article.description" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article.description}}</div>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionStoryDelete">
                    <v-btn text flat icon @click="deleteStoryConfirmation = true; selectedStory = ['globalPoliticsStories', index, 'globalPoliticsStoriesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                    <v-btn text flat icon @click="displayContent('globalPoliticsStoriesDisplay', index)" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon class="newsCoverageSectionStoryExpand" :class="globalPoliticsStoriesDisplay[index] ? 'newsCoverageSectionStoryExpandRotate' : ''">fas fa-chevron-down</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionStorySources">
                  <div v-for="(article, index2) in story.articles" :key="index2" style="padding-right: 3px;">
                    <a :href="article.url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article.domain)}}<span v-if="index2 !== story.articles.length - 1">,</span></a>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="saudiPoliticsStories.length > 0">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- SAUDI:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicSaudiStoriesConfirmation = true; selectedTopic = 'Politics'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(story, index) in saudiPoliticsStories" :key="index">
                <div class="newsCoverageSectionStoryContainer">
                  <div class="newsCoverageSectionStory">
                    <v-radio-group light v-model="saudiPoliticsStoriesSelection[index]" column class="mt-0">
                      <v-radio :value="story.title + '.'" color="secondary">
                        <div slot="label" class="secondary--text body-2">{{story.title + '.'}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(story.articleCount) + ' articles'}}</div>
                      <div>{{formatNumber(story.domainCount) + ' sources'}}</div>
                      <div>{{formatNumber(story.facebookComments) + ' Facebook comments'}}</div>
                      <div>{{formatNumber(story.facebookReactions) + ' Facebook reactions'}}</div>
                      <div>{{formatNumber(story.facebookShares) + ' Facebook shares'}}</div>
                      <div>{{formatNumber(story.tweetCount) + ' tweets'}}</div>
                      <div>{{formatNumber(story.impressionCount) + ' impressions'}}</div>
                      <div>{{formatNumber(story.userCount) + ' users'}}</div>
                    </div>
                    <div class="newsCoverageSectionStoryArticles" v-if="saudiPoliticsStoriesDisplay[index]">
                      <div v-for="(article, index1) in story.articles" class="newsCoverageSectionStoryArticle">
                        <div class="mb-0">
                          <v-radio-group light v-model="saudiPoliticsStoriesSelection[index]" column class="mt-0">
                            <v-radio :value="article.title" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article.title}}</div>
                            </v-radio>
                            <v-radio :value="article.description" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article.description}}</div>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionStoryDelete">
                    <v-btn text flat icon @click="deleteStoryConfirmation = true; selectedStory = ['saudiPoliticsStories', index, 'saudiPoliticsStoriesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                    <v-btn text flat icon @click="displayContent('saudiPoliticsStoriesDisplay', index)" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon class="newsCoverageSectionStoryExpand" :class="saudiPoliticsStoriesDisplay[index] ? 'newsCoverageSectionStoryExpandRotate' : ''">fas fa-chevron-down</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionStorySources">
                  <div v-for="(article, index2) in story.articles" :key="index2" style="padding-right: 3px;">
                    <a :href="article.url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article.domain)}}<span v-if="index2 !== story.articles.length - 1">,</span></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newsCoverageSection" v-if="globalPoliticsArticles.length > 0 || saudiPoliticsArticles.length > 0" :class="globalPoliticsStories.length > 0 || saudiPoliticsStories.length > 0 ? 'mt-2' : ''">
          <div class="newsCoverageTopicHeader">
            <div class="subtitle-2 newsCoverageTopicHeaderTitle">- Articles:</div>
            <div class="newsCoverageTopicHeaderBtn">
              <v-btn text flat icon @click="deleteTopicArticlesConfirmation = true; selectedTopic = 'Politics'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
            </div>
          </div>
          <div class="newsCoverageSectionArticles">
            <div v-if="globalPoliticsArticles.length > 0" :class="saudiPoliticsArticles.length > 0 ? 'mb-2' : ''">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- GLOBAL:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicGlobalArticlesConfirmation = true; selectedTopic = 'Politics'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(article, index) in globalPoliticsArticles" :key="index">
                <div class="newsCoverageSectionArticleContainer">
                  <div class="newsCoverageSectionArticle">
                    <v-radio-group hide-details light v-model="globalPoliticsArticlesSelection[index]" column class="mt-0">
                      <v-radio :value="article._title" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article._title}}</div>
                      </v-radio>
                      <v-radio :value="article._description" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article._description}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(article._tweeted_count) + ' tweets'}}</div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionArticleDelete">
                    <v-btn text flat icon @click="deleteArticleConfirmation = true; selectedArticle = ['globalPoliticsArticles', index, 'globalPoliticsArticlesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionArticleSource">
                  <a :href="article._url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article._domain)}}</a>
                </div>
              </div>
            </div>
            <div v-if="saudiPoliticsArticles.length > 0">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- SAUDI:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicSaudiArticlesConfirmation = true; selectedTopic = 'Politics'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(article, index) in saudiPoliticsArticles" :key="index">
                <div class="newsCoverageSectionArticleContainer">
                  <div class="newsCoverageSectionArticle">
                    <v-radio-group hide-details light v-model="saudiPoliticsArticlesSelection[index]" column class="mt-0">
                      <v-radio :value="article._title" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article._title}}</div>
                      </v-radio>
                      <v-radio :value="article._description" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article._description}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(article._tweeted_count) + ' tweets'}}</div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionArticleDelete">
                    <v-btn text flat icon @click="deleteArticleConfirmation = true; selectedArticle = ['saudiPoliticsArticles', index, 'saudiPoliticsArticlesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionArticleSource">
                  <a :href="article._url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article._domain)}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="newsCoverage pt-2 mb-3" v-if="globalTourismStories.length > 0 || saudiTourismStories.length > 0 || globalTourismArticles.length > 0 || saudiTourismArticles.length > 0">
        <div class="newsCoverageTopicHeader">
          <div class="subtitle-1 newsCoverageTopicHeaderTitle">- TOURISM:</div>
          <div class="newsCoverageTopicHeaderBtn">
            <v-btn text flat icon @click="deleteTopicConfirmation = true; selectedTopic = 'Tourism'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
          </div>
        </div>
        <div class="newsCoverageSection" v-if="globalTourismStories.length > 0 || saudiTourismStories.length > 0">
          <div class="newsCoverageTopicHeader">
            <div class="subtitle-2 newsCoverageTopicHeaderTitle">- Stories:</div>
            <div class="newsCoverageTopicHeaderBtn">
              <v-btn text flat icon @click="deleteTopicStoriesConfirmation = true; selectedTopic = 'Tourism'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
            </div>
          </div>
          <div class="newsCoverageSectionStories">
            <div v-if="globalTourismStories.length > 0" :class="saudiTourismStories.length > 0 ? 'mb-2' : ''">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- GLOBAL:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicGlobalStoriesConfirmation = true; selectedTopic = 'Tourism'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(story, index) in globalTourismStories" :key="index">
                <div class="newsCoverageSectionStoryContainer">
                  <div class="newsCoverageSectionStory">
                    <v-radio-group light v-model="globalTourismStoriesSelection[index]" column class="mt-0">
                      <v-radio :value="story.title + '.'" color="secondary">
                        <div slot="label" class="secondary--text body-2">{{story.title + '.'}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(story.articleCount) + ' articles'}}</div>
                      <div>{{formatNumber(story.domainCount) + ' sources'}}</div>
                      <div>{{formatNumber(story.facebookComments) + ' Facebook comments'}}</div>
                      <div>{{formatNumber(story.facebookReactions) + ' Facebook reactions'}}</div>
                      <div>{{formatNumber(story.facebookShares) + ' Facebook shares'}}</div>
                      <div>{{formatNumber(story.tweetCount) + ' tweets'}}</div>
                      <div>{{formatNumber(story.impressionCount) + ' impressions'}}</div>
                      <div>{{formatNumber(story.userCount) + ' users'}}</div>
                    </div>
                    <div class="newsCoverageSectionStoryArticles" v-if="globalTourismStoriesDisplay[index]">
                      <div v-for="(article, index1) in story.articles" class="newsCoverageSectionStoryArticle">
                        <div class="mb-0">
                          <v-radio-group light v-model="globalTourismStoriesSelection[index]" column class="mt-0">
                            <v-radio :value="article.title" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article.title}}</div>
                            </v-radio>
                            <v-radio :value="article.description" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article.description}}</div>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionStoryDelete">
                    <v-btn text flat icon @click="deleteStoryConfirmation = true; selectedStory = ['globalTourismStories', index, 'globalTourismStoriesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                    <v-btn text flat icon @click="displayContent('globalTourismStoriesDisplay', index)" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon class="newsCoverageSectionStoryExpand" :class="globalTourismStoriesDisplay[index] ? 'newsCoverageSectionStoryExpandRotate' : ''">fas fa-chevron-down</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionStorySources">
                  <div v-for="(article, index2) in story.articles" :key="index2" style="padding-right: 3px;">
                    <a :href="article.url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article.domain)}}<span v-if="index2 !== story.articles.length - 1">,</span></a>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="saudiTourismStories.length > 0">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- SAUDI:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicSaudiStoriesConfirmation = true; selectedTopic = 'Tourism'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(story, index) in saudiTourismStories" :key="index">
                <div class="newsCoverageSectionStoryContainer">
                  <div class="newsCoverageSectionStory">
                    <v-radio-group light v-model="saudiTourismStoriesSelection[index]" column class="mt-0">
                      <v-radio :value="story.title + '.'" color="secondary">
                        <div slot="label" class="secondary--text body-2">{{story.title + '.'}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(story.articleCount) + ' articles'}}</div>
                      <div>{{formatNumber(story.domainCount) + ' sources'}}</div>
                      <div>{{formatNumber(story.facebookComments) + ' Facebook comments'}}</div>
                      <div>{{formatNumber(story.facebookReactions) + ' Facebook reactions'}}</div>
                      <div>{{formatNumber(story.facebookShares) + ' Facebook shares'}}</div>
                      <div>{{formatNumber(story.tweetCount) + ' tweets'}}</div>
                      <div>{{formatNumber(story.impressionCount) + ' impressions'}}</div>
                      <div>{{formatNumber(story.userCount) + ' users'}}</div>
                    </div>
                    <div class="newsCoverageSectionStoryArticles" v-if="saudiTourismStoriesDisplay[index]">
                      <div v-for="(article, index1) in story.articles" class="newsCoverageSectionStoryArticle">
                        <div class="mb-0">
                          <v-radio-group light v-model="saudiTourismStoriesSelection[index]" column class="mt-0">
                            <v-radio :value="article.title" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article.title}}</div>
                            </v-radio>
                            <v-radio :value="article.description" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article.description}}</div>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionStoryDelete">
                    <v-btn text flat icon @click="deleteStoryConfirmation = true; selectedStory = ['saudiTourismStories', index, 'saudiTourismStoriesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                    <v-btn text flat icon @click="displayContent('saudiTourismStoriesDisplay', index)" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon class="newsCoverageSectionStoryExpand" :class="saudiTourismStoriesDisplay[index] ? 'newsCoverageSectionStoryExpandRotate' : ''">fas fa-chevron-down</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionStorySources">
                  <div v-for="(article, index2) in story.articles" :key="index2" style="padding-right: 3px;">
                    <a :href="article.url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article.domain)}}<span v-if="index2 !== story.articles.length - 1">,</span></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newsCoverageSection" v-if="globalTourismArticles.length > 0 || saudiTourismArticles.length > 0" :class="globalTourismStories.length > 0 || saudiTourismStories.length > 0 ? 'mt-2' : ''">
          <div class="newsCoverageTopicHeader">
            <div class="subtitle-2 newsCoverageTopicHeaderTitle">- Articles:</div>
            <div class="newsCoverageTopicHeaderBtn">
              <v-btn text flat icon @click="deleteTopicArticlesConfirmation = true; selectedTopic = 'Tourism'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
            </div>
          </div>
          <div class="newsCoverageSectionArticles">
            <div v-if="globalTourismArticles.length > 0" :class="saudiTourismArticles.length > 0 ? 'mb-2' : ''">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- GLOBAL:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicGlobalArticlesConfirmation = true; selectedTopic = 'Tourism'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(article, index) in globalTourismArticles" :key="index">
                <div class="newsCoverageSectionArticleContainer">
                  <div class="newsCoverageSectionArticle">
                    <v-radio-group hide-details light v-model="globalTourismArticlesSelection[index]" column class="mt-0">
                      <v-radio :value="article._title" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article._title}}</div>
                      </v-radio>
                      <v-radio :value="article._description" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article._description}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(article._tweeted_count) + ' tweets'}}</div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionArticleDelete">
                    <v-btn text flat icon @click="deleteArticleConfirmation = true; selectedArticle = ['globalTourismArticles', index, 'globalTourismArticlesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionArticleSource">
                  <a :href="article._url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article._domain)}}</a>
                </div>
              </div>
            </div>
            <div v-if="saudiTourismArticles.length > 0">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- SAUDI:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicSaudiArticlesConfirmation = true; selectedTopic = 'Tourism'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(article, index) in saudiTourismArticles" :key="index">
                <div class="newsCoverageSectionArticleContainer">
                  <div class="newsCoverageSectionArticle">
                    <v-radio-group hide-details light v-model="saudiTourismArticlesSelection[index]" column class="mt-0">
                      <v-radio :value="article._title" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article._title}}</div>
                      </v-radio>
                      <v-radio :value="article._description" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article._description}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(article._tweeted_count) + ' tweets'}}</div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionArticleDelete">
                    <v-btn text flat icon @click="deleteArticleConfirmation = true; selectedArticle = ['saudiTourismArticles', index, 'saudiTourismArticlesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionArticleSource">
                  <a :href="article._url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article._domain)}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="newsCoverage pt-2 mb-3" v-if="globalBusinessStories.length > 0 || saudiBusinessStories.length > 0 || globalBusinessArticles.length > 0 || saudiBusinessArticles.length > 0">
        <div class="newsCoverageTopicHeader">
          <div class="subtitle-1 newsCoverageTopicHeaderTitle">- BUSINESS:</div>
          <div class="newsCoverageTopicHeaderBtn">
            <v-btn text flat icon @click="deleteTopicConfirmation = true; selectedTopic = 'Business'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
          </div>
        </div>
        <div class="newsCoverageSection" v-if="globalBusinessStories.length > 0 || saudiBusinessStories.length > 0">
          <div class="newsCoverageTopicHeader">
            <div class="subtitle-2 newsCoverageTopicHeaderTitle">- Stories:</div>
            <div class="newsCoverageTopicHeaderBtn">
              <v-btn text flat icon @click="deleteTopicStoriesConfirmation = true; selectedTopic = 'Business'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
            </div>
          </div>
          <div class="newsCoverageSectionStories">
            <div v-if="globalBusinessStories.length > 0" :class="saudiBusinessStories.length > 0 ? 'mb-2' : ''">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- GLOBAL:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicGlobalStoriesConfirmation = true; selectedTopic = 'Business'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(story, index) in globalBusinessStories" :key="index">
                <div class="newsCoverageSectionStoryContainer">
                  <div class="newsCoverageSectionStory">
                    <v-radio-group light v-model="globalBusinessStoriesSelection[index]" column class="mt-0">
                      <v-radio :value="story.title + '.'" color="secondary">
                        <div slot="label" class="secondary--text body-2">{{story.title + '.'}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(story.articleCount) + ' articles'}}</div>
                      <div>{{formatNumber(story.domainCount) + ' sources'}}</div>
                      <div>{{formatNumber(story.facebookComments) + ' Facebook comments'}}</div>
                      <div>{{formatNumber(story.facebookReactions) + ' Facebook reactions'}}</div>
                      <div>{{formatNumber(story.facebookShares) + ' Facebook shares'}}</div>
                      <div>{{formatNumber(story.tweetCount) + ' tweets'}}</div>
                      <div>{{formatNumber(story.impressionCount) + ' impressions'}}</div>
                      <div>{{formatNumber(story.userCount) + ' users'}}</div>
                    </div>
                    <div class="newsCoverageSectionStoryArticles" v-if="globalBusinessStoriesDisplay[index]">
                      <div v-for="(article, index1) in story.articles" class="newsCoverageSectionStoryArticle">
                        <div class="mb-0">
                          <v-radio-group light v-model="globalBusinessStoriesSelection[index]" column class="mt-0">
                            <v-radio :value="article.title" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article.title}}</div>
                            </v-radio>
                            <v-radio :value="article.description" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article.description}}</div>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionStoryDelete">
                    <v-btn text flat icon @click="deleteStoryConfirmation = true; selectedStory = ['globalBusinessStories', index, 'globalBusinessStoriesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                    <v-btn text flat icon @click="displayContent('globalBusinessStoriesDisplay', index)" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon class="newsCoverageSectionStoryExpand" :class="globalBusinessStoriesDisplay[index] ? 'newsCoverageSectionStoryExpandRotate' : ''">fas fa-chevron-down</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionStorySources">
                  <div v-for="(article, index2) in story.articles" :key="index2" style="padding-right: 3px;">
                    <a :href="article.url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article.domain)}}<span v-if="index2 !== story.articles.length - 1">,</span></a>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="saudiBusinessStories.length > 0">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- SAUDI:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicSaudiStoriesConfirmation = true; selectedTopic = 'Business'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(story, index) in saudiBusinessStories" :key="index">
                <div class="newsCoverageSectionStoryContainer">
                  <div class="newsCoverageSectionStory">
                    <v-radio-group light v-model="saudiBusinessStoriesSelection[index]" column class="mt-0">
                      <v-radio :value="story.title + '.'" color="secondary">
                        <div slot="label" class="secondary--text body-2">{{story.title + '.'}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(story.articleCount) + ' articles'}}</div>
                      <div>{{formatNumber(story.domainCount) + ' sources'}}</div>
                      <div>{{formatNumber(story.facebookComments) + ' Facebook comments'}}</div>
                      <div>{{formatNumber(story.facebookReactions) + ' Facebook reactions'}}</div>
                      <div>{{formatNumber(story.facebookShares) + ' Facebook shares'}}</div>
                      <div>{{formatNumber(story.tweetCount) + ' tweets'}}</div>
                      <div>{{formatNumber(story.impressionCount) + ' impressions'}}</div>
                      <div>{{formatNumber(story.userCount) + ' users'}}</div>
                    </div>
                    <div class="newsCoverageSectionStoryArticles" v-if="saudiBusinessStoriesDisplay[index]">
                      <div v-for="(article, index1) in story.articles" class="newsCoverageSectionStoryArticle">
                        <div class="mb-0">
                          <v-radio-group light v-model="saudiBusinessStoriesSelection[index]" column class="mt-0">
                            <v-radio :value="article.title" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article.title}}</div>
                            </v-radio>
                            <v-radio :value="article.description" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article.description}}</div>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionStoryDelete">
                    <v-btn text flat icon @click="deleteStoryConfirmation = true; selectedStory = ['saudiBusinessStories', index, 'saudiBusinessStoriesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                    <v-btn text flat icon @click="displayContent('saudiBusinessStoriesDisplay', index)" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon class="newsCoverageSectionStoryExpand" :class="saudiBusinessStoriesDisplay[index] ? 'newsCoverageSectionStoryExpandRotate' : ''">fas fa-chevron-down</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionStorySources">
                  <div v-for="(article, index2) in story.articles" :key="index2" style="padding-right: 3px;">
                    <a :href="article.url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article.domain)}}<span v-if="index2 !== story.articles.length - 1">,</span></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newsCoverageSection" v-if="globalBusinessArticles.length > 0 || saudiBusinessArticles.length > 0" :class="globalBusinessStories.length > 0 || saudiBusinessStories.length > 0 ? 'mt-2' : ''">
          <div class="newsCoverageTopicHeader">
            <div class="subtitle-2 newsCoverageTopicHeaderTitle">- Articles:</div>
            <div class="newsCoverageTopicHeaderBtn">
              <v-btn text flat icon @click="deleteTopicArticlesConfirmation = true; selectedTopic = 'Business'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
            </div>
          </div>
          <div class="newsCoverageSectionArticles">
            <div v-if="globalBusinessArticles.length > 0" :class="saudiBusinessArticles.length > 0 ? 'mb-2' : ''">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- GLOBAL:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicGlobalArticlesConfirmation = true; selectedTopic = 'Business'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(article, index) in globalBusinessArticles" :key="index">
                <div class="newsCoverageSectionArticleContainer">
                  <div class="newsCoverageSectionArticle">
                    <v-radio-group hide-details light v-model="globalBusinessArticlesSelection[index]" column class="mt-0">
                      <v-radio :value="article._title" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article._title}}</div>
                      </v-radio>
                      <v-radio :value="article._description" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article._description}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(article._tweeted_count) + ' tweets'}}</div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionArticleDelete">
                    <v-btn text flat icon @click="deleteArticleConfirmation = true; selectedArticle = ['globalBusinessArticles', index, 'globalBusinessArticlesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionArticleSource">
                  <a :href="article._url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article._domain)}}</a>
                </div>
              </div>
            </div>
            <div v-if="saudiBusinessArticles.length > 0">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- SAUDI:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicSaudiArticlesConfirmation = true; selectedTopic = 'Business'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(article, index) in saudiBusinessArticles" :key="index">
                <div class="newsCoverageSectionArticleContainer">
                  <div class="newsCoverageSectionArticle">
                    <v-radio-group hide-details light v-model="saudiBusinessArticlesSelection[index]" column class="mt-0">
                      <v-radio :value="article._title" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article._title}}</div>
                      </v-radio>
                      <v-radio :value="article._description" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article._description}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(article._tweeted_count) + ' tweets'}}</div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionArticleDelete">
                    <v-btn text flat icon @click="deleteArticleConfirmation = true; selectedArticle = ['saudiBusinessArticles', index, 'saudiBusinessArticlesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionArticleSource">
                  <a :href="article._url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article._domain)}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="newsCoverage pt-2 mb-3" v-if="globalTechStories.length > 0 || saudiTechStories.length > 0 || globalTechArticles.length > 0 || saudiTechArticles.length > 0">
        <div class="newsCoverageTopicHeader">
          <div class="subtitle-1 newsCoverageTopicHeaderTitle">- TECH:</div>
          <div class="newsCoverageTopicHeaderBtn">
            <v-btn text flat icon @click="deleteTopicConfirmation = true; selectedTopic = 'Tech'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
          </div>
        </div>
        <div class="newsCoverageSection" v-if="globalTechStories.length > 0 || saudiTechStories.length > 0">
          <div class="newsCoverageTopicHeader">
            <div class="subtitle-2 newsCoverageTopicHeaderTitle">- Stories:</div>
            <div class="newsCoverageTopicHeaderBtn">
              <v-btn text flat icon @click="deleteTopicStoriesConfirmation = true; selectedTopic = 'Tech'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
            </div>
          </div>
          <div class="newsCoverageSectionStories">
            <div v-if="globalTechStories.length > 0" :class="saudiTechStories.length > 0 ? 'mb-2' : ''">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- GLOBAL:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicGlobalStoriesConfirmation = true; selectedTopic = 'Tech'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(story, index) in globalTechStories" :key="index">
                <div class="newsCoverageSectionStoryContainer">
                  <div class="newsCoverageSectionStory">
                    <v-radio-group light v-model="globalTechStoriesSelection[index]" column class="mt-0">
                      <v-radio :value="story.title + '.'" color="secondary">
                        <div slot="label" class="secondary--text body-2">{{story.title + '.'}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(story.articleCount) + ' articles'}}</div>
                      <div>{{formatNumber(story.domainCount) + ' sources'}}</div>
                      <div>{{formatNumber(story.facebookComments) + ' Facebook comments'}}</div>
                      <div>{{formatNumber(story.facebookReactions) + ' Facebook reactions'}}</div>
                      <div>{{formatNumber(story.facebookShares) + ' Facebook shares'}}</div>
                      <div>{{formatNumber(story.tweetCount) + ' tweets'}}</div>
                      <div>{{formatNumber(story.impressionCount) + ' impressions'}}</div>
                      <div>{{formatNumber(story.userCount) + ' users'}}</div>
                    </div>
                    <div class="newsCoverageSectionStoryArticles" v-if="globalTechStoriesDisplay[index]">
                      <div v-for="(article, index1) in story.articles" class="newsCoverageSectionStoryArticle">
                        <div class="mb-0">
                          <v-radio-group light v-model="globalTechStoriesSelection[index]" column class="mt-0">
                            <v-radio :value="article.title" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article.title}}</div>
                            </v-radio>
                            <v-radio :value="article.description" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article.description}}</div>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionStoryDelete">
                    <v-btn text flat icon @click="deleteStoryConfirmation = true; selectedStory = ['globalTechStories', index, 'globalTechStoriesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                    <v-btn text flat icon @click="displayContent('globalTechStoriesDisplay', index)" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon class="newsCoverageSectionStoryExpand" :class="globalTechStoriesDisplay[index] ? 'newsCoverageSectionStoryExpandRotate' : ''">fas fa-chevron-down</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionStorySources">
                  <div v-for="(article, index2) in story.articles" :key="index2" style="padding-right: 3px;">
                    <a :href="article.url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article.domain)}}<span v-if="index2 !== story.articles.length - 1">,</span></a>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="saudiTechStories.length > 0">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- SAUDI:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicSaudiStoriesConfirmation = true; selectedTopic = 'Tech'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(story, index) in saudiTechStories" :key="index">
                <div class="newsCoverageSectionStoryContainer">
                  <div class="newsCoverageSectionStory">
                    <v-radio-group light v-model="saudiTechStoriesSelection[index]" column class="mt-0">
                      <v-radio :value="story.title + '.'" color="secondary">
                        <div slot="label" class="secondary--text body-2">{{story.title + '.'}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(story.articleCount) + ' articles'}}</div>
                      <div>{{formatNumber(story.domainCount) + ' sources'}}</div>
                      <div>{{formatNumber(story.facebookComments) + ' Facebook comments'}}</div>
                      <div>{{formatNumber(story.facebookReactions) + ' Facebook reactions'}}</div>
                      <div>{{formatNumber(story.facebookShares) + ' Facebook shares'}}</div>
                      <div>{{formatNumber(story.tweetCount) + ' tweets'}}</div>
                      <div>{{formatNumber(story.impressionCount) + ' impressions'}}</div>
                      <div>{{formatNumber(story.userCount) + ' users'}}</div>
                    </div>
                    <div class="newsCoverageSectionStoryArticles" v-if="saudiTechStoriesDisplay[index]">
                      <div v-for="(article, index1) in story.articles" class="newsCoverageSectionStoryArticle">
                        <div class="mb-0">
                          <v-radio-group light v-model="saudiTechStoriesSelection[index]" column class="mt-0">
                            <v-radio :value="article.title" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article.title}}</div>
                            </v-radio>
                            <v-radio :value="article.description" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article.description}}</div>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionStoryDelete">
                    <v-btn text flat icon @click="deleteStoryConfirmation = true; selectedStory = ['saudiTechStories', index, 'saudiTechStoriesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                    <v-btn text flat icon @click="displayContent('saudiTechStoriesDisplay', index)" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon class="newsCoverageSectionStoryExpand" :class="saudiTechStoriesDisplay[index] ? 'newsCoverageSectionStoryExpandRotate' : ''">fas fa-chevron-down</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionStorySources">
                  <div v-for="(article, index2) in story.articles" :key="index2" style="padding-right: 3px;">
                    <a :href="article.url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article.domain)}}<span v-if="index2 !== story.articles.length - 1">,</span></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newsCoverageSection" v-if="globalTechArticles.length > 0 || saudiTechArticles.length > 0" :class="globalTechStories.length > 0 || saudiTechStories.length > 0 ? 'mt-2' : ''">
          <div class="newsCoverageTopicHeader">
            <div class="subtitle-2 newsCoverageTopicHeaderTitle">- Articles:</div>
            <div class="newsCoverageTopicHeaderBtn">
              <v-btn text flat icon @click="deleteTopicArticlesConfirmation = true; selectedTopic = 'Tech'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
            </div>
          </div>
          <div class="newsCoverageSectionArticles">
            <div v-if="globalTechArticles.length > 0" :class="saudiTechArticles.length > 0 ? 'mb-2' : ''">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- GLOBAL:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicGlobalArticlesConfirmation = true; selectedTopic = 'Tech'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(article, index) in globalTechArticles" :key="index">
                <div class="newsCoverageSectionArticleContainer">
                  <div class="newsCoverageSectionArticle">
                    <v-radio-group hide-details light v-model="globalTechArticlesSelection[index]" column class="mt-0">
                      <v-radio :value="article._title" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article._title}}</div>
                      </v-radio>
                      <v-radio :value="article._description" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article._description}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(article._tweeted_count) + ' tweets'}}</div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionArticleDelete">
                    <v-btn text flat icon @click="deleteArticleConfirmation = true; selectedArticle = ['globalTechArticles', index, 'globalTechArticlesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionArticleSource">
                  <a :href="article._url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article._domain)}}</a>
                </div>
              </div>
            </div>
            <div v-if="saudiTechArticles.length > 0">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- SAUDI:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicSaudiArticlesConfirmation = true; selectedTopic = 'Tech'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(article, index) in saudiTechArticles" :key="index">
                <div class="newsCoverageSectionArticleContainer">
                  <div class="newsCoverageSectionArticle">
                    <v-radio-group hide-details light v-model="saudiTechArticlesSelection[index]" column class="mt-0">
                      <v-radio :value="article._title" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article._title}}</div>
                      </v-radio>
                      <v-radio :value="article._description" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article._description}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(article._tweeted_count) + ' tweets'}}</div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionArticleDelete">
                    <v-btn text flat icon @click="deleteArticleConfirmation = true; selectedArticle = ['saudiTechArticles', index, 'saudiTechArticlesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionArticleSource">
                  <a :href="article._url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article._domain)}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="newsCoverage pt-2 mb-3" v-if="globalSocialStories.length > 0 || saudiSocialStories.length > 0 || globalSocialArticles.length > 0 || saudiSocialArticles.length > 0">
        <div class="newsCoverageTopicHeader">
          <div class="subtitle-1 newsCoverageTopicHeaderTitle">- SOCIAL:</div>
          <div class="newsCoverageTopicHeaderBtn">
            <v-btn text flat icon @click="deleteTopicConfirmation = true; selectedTopic = 'Social'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
          </div>
        </div>
        <div class="newsCoverageSection" v-if="globalSocialStories.length > 0 || saudiSocialStories.length > 0">
          <div class="newsCoverageTopicHeader">
            <div class="subtitle-2 newsCoverageTopicHeaderTitle">- Stories:</div>
            <div class="newsCoverageTopicHeaderBtn">
              <v-btn text flat icon @click="deleteTopicStoriesConfirmation = true; selectedTopic = 'Social'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
            </div>
          </div>
          <div class="newsCoverageSectionStories">
            <div v-if="globalSocialStories.length > 0" :class="saudiSocialStories.length > 0 ? 'mb-2' : ''">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- GLOBAL:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicGlobalStoriesConfirmation = true; selectedTopic = 'Social'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(story, index) in globalSocialStories" :key="index">
                <div class="newsCoverageSectionStoryContainer">
                  <div class="newsCoverageSectionStory">
                    <v-radio-group light v-model="globalSocialStoriesSelection[index]" column class="mt-0">
                      <v-radio :value="story.title + '.'" color="secondary">
                        <div slot="label" class="secondary--text body-2">{{story.title + '.'}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(story.articleCount) + ' articles'}}</div>
                      <div>{{formatNumber(story.domainCount) + ' sources'}}</div>
                      <div>{{formatNumber(story.facebookComments) + ' Facebook comments'}}</div>
                      <div>{{formatNumber(story.facebookReactions) + ' Facebook reactions'}}</div>
                      <div>{{formatNumber(story.facebookShares) + ' Facebook shares'}}</div>
                      <div>{{formatNumber(story.tweetCount) + ' tweets'}}</div>
                      <div>{{formatNumber(story.impressionCount) + ' impressions'}}</div>
                      <div>{{formatNumber(story.userCount) + ' users'}}</div>
                    </div>
                    <div class="newsCoverageSectionStoryArticles" v-if="globalSocialStoriesDisplay[index]">
                      <div v-for="(article, index1) in story.articles" class="newsCoverageSectionStoryArticle">
                        <div class="mb-0">
                          <v-radio-group light v-model="globalSocialStoriesSelection[index]" column class="mt-0">
                            <v-radio :value="article.title" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article.title}}</div>
                            </v-radio>
                            <v-radio :value="article.description" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article.description}}</div>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionStoryDelete">
                    <v-btn text flat icon @click="deleteStoryConfirmation = true; selectedStory = ['globalSocialStories', index, 'globalSocialStoriesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                    <v-btn text flat icon @click="displayContent('globalSocialStoriesDisplay', index)" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon class="newsCoverageSectionStoryExpand" :class="globalSocialStoriesDisplay[index] ? 'newsCoverageSectionStoryExpandRotate' : ''">fas fa-chevron-down</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionStorySources">
                  <div v-for="(article, index2) in story.articles" :key="index2" style="padding-right: 3px;">
                    <a :href="article.url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article.domain)}}<span v-if="index2 !== story.articles.length - 1">,</span></a>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="saudiSocialStories.length > 0">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- SAUDI:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicSaudiStoriesConfirmation = true; selectedTopic = 'Social'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(story, index) in saudiSocialStories" :key="index">
                <div class="newsCoverageSectionStoryContainer">
                  <div class="newsCoverageSectionStory">
                    <v-radio-group light v-model="saudiSocialStoriesSelection[index]" column class="mt-0">
                      <v-radio :value="story.title + '.'" color="secondary">
                        <div slot="label" class="secondary--text body-2">{{story.title + '.'}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(story.articleCount) + ' articles'}}</div>
                      <div>{{formatNumber(story.domainCount) + ' sources'}}</div>
                      <div>{{formatNumber(story.facebookComments) + ' Facebook comments'}}</div>
                      <div>{{formatNumber(story.facebookReactions) + ' Facebook reactions'}}</div>
                      <div>{{formatNumber(story.facebookShares) + ' Facebook shares'}}</div>
                      <div>{{formatNumber(story.tweetCount) + ' tweets'}}</div>
                      <div>{{formatNumber(story.impressionCount) + ' impressions'}}</div>
                      <div>{{formatNumber(story.userCount) + ' users'}}</div>
                    </div>
                    <div class="newsCoverageSectionStoryArticles" v-if="saudiSocialStoriesDisplay[index]">
                      <div v-for="(article, index1) in story.articles" class="newsCoverageSectionStoryArticle">
                        <div class="mb-0">
                          <v-radio-group light v-model="saudiSocialStoriesSelection[index]" column class="mt-0">
                            <v-radio :value="article.title" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article.title}}</div>
                            </v-radio>
                            <v-radio :value="article.description" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article.description}}</div>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionStoryDelete">
                    <v-btn text flat icon @click="deleteStoryConfirmation = true; selectedStory = ['saudiSocialStories', index, 'saudiSocialStoriesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                    <v-btn text flat icon @click="displayContent('saudiSocialStoriesDisplay', index)" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon class="newsCoverageSectionStoryExpand" :class="saudiSocialStoriesDisplay[index] ? 'newsCoverageSectionStoryExpandRotate' : ''">fas fa-chevron-down</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionStorySources">
                  <div v-for="(article, index2) in story.articles" :key="index2" style="padding-right: 3px;">
                    <a :href="article.url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article.domain)}}<span v-if="index2 !== story.articles.length - 1">,</span></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newsCoverageSection" v-if="globalSocialArticles.length > 0 || saudiSocialArticles.length > 0" :class="globalSocialStories.length > 0 || saudiSocialStories.length > 0 ? 'mt-2' : ''">
          <div class="newsCoverageTopicHeader">
            <div class="subtitle-2 newsCoverageTopicHeaderTitle">- Articles:</div>
            <div class="newsCoverageTopicHeaderBtn">
              <v-btn text flat icon @click="deleteTopicArticlesConfirmation = true; selectedTopic = 'Social'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
            </div>
          </div>
          <div class="newsCoverageSectionArticles">
            <div v-if="globalSocialArticles.length > 0" :class="saudiSocialArticles.length > 0 ? 'mb-2' : ''">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- GLOBAL:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicGlobalArticlesConfirmation = true; selectedTopic = 'Social'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(article, index) in globalSocialArticles" :key="index">
                <div class="newsCoverageSectionArticleContainer">
                  <div class="newsCoverageSectionArticle">
                    <v-radio-group hide-details light v-model="globalSocialArticlesSelection[index]" column class="mt-0">
                      <v-radio :value="article._title" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article._title}}</div>
                      </v-radio>
                      <v-radio :value="article._description" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article._description}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(article._tweeted_count) + ' tweets'}}</div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionArticleDelete">
                    <v-btn text flat icon @click="deleteArticleConfirmation = true; selectedArticle = ['globalSocialArticles', index, 'globalSocialArticlesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionArticleSource">
                  <a :href="article._url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article._domain)}}</a>
                </div>
              </div>
            </div>
            <div v-if="saudiSocialArticles.length > 0">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- SAUDI:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicSaudiArticlesConfirmation = true; selectedTopic = 'Social'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(article, index) in saudiSocialArticles" :key="index">
                <div class="newsCoverageSectionArticleContainer">
                  <div class="newsCoverageSectionArticle">
                    <v-radio-group hide-details light v-model="saudiSocialArticlesSelection[index]" column class="mt-0">
                      <v-radio :value="article._title" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article._title}}</div>
                      </v-radio>
                      <v-radio :value="article._description" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article._description}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(article._tweeted_count) + ' tweets'}}</div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionArticleDelete">
                    <v-btn text flat icon @click="deleteArticleConfirmation = true; selectedArticle = ['saudiSocialArticles', index, 'saudiSocialArticlesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionArticleSource">
                  <a :href="article._url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article._domain)}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="newsCoverage pt-2 mb-3" v-if="globalEnvironmentStories.length > 0 || saudiEnvironmentStories.length > 0 || globalEnvironmentArticles.length > 0 || saudiEnvironmentArticles.length > 0">
        <div class="newsCoverageTopicHeader">
          <div class="subtitle-1 newsCoverageTopicHeaderTitle">- ENVIRONMENT:</div>
          <div class="newsCoverageTopicHeaderBtn">
            <v-btn text flat icon @click="deleteTopicConfirmation = true; selectedTopic = 'Environment'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
          </div>
        </div>
        <div class="newsCoverageSection" v-if="globalEnvironmentStories.length > 0 || saudiEnvironmentStories.length > 0">
          <div class="newsCoverageTopicHeader">
            <div class="subtitle-2 newsCoverageTopicHeaderTitle">- Stories:</div>
            <div class="newsCoverageTopicHeaderBtn">
              <v-btn text flat icon @click="deleteTopicStoriesConfirmation = true; selectedTopic = 'Environment'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
            </div>
          </div>
          <div class="newsCoverageSectionStories">
            <div v-if="globalEnvironmentStories.length > 0" :class="saudiEnvironmentStories.length > 0 ? 'mb-2' : ''">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- GLOBAL:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicGlobalStoriesConfirmation = true; selectedTopic = 'Environment'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(story, index) in globalEnvironmentStories" :key="index">
                <div class="newsCoverageSectionStoryContainer">
                  <div class="newsCoverageSectionStory">
                    <v-radio-group light v-model="globalEnvironmentStoriesSelection[index]" column class="mt-0">
                      <v-radio :value="story.title + '.'" color="secondary">
                        <div slot="label" class="secondary--text body-2">{{story.title + '.'}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(story.articleCount) + ' articles'}}</div>
                      <div>{{formatNumber(story.domainCount) + ' sources'}}</div>
                      <div>{{formatNumber(story.facebookComments) + ' Facebook comments'}}</div>
                      <div>{{formatNumber(story.facebookReactions) + ' Facebook reactions'}}</div>
                      <div>{{formatNumber(story.facebookShares) + ' Facebook shares'}}</div>
                      <div>{{formatNumber(story.tweetCount) + ' tweets'}}</div>
                      <div>{{formatNumber(story.impressionCount) + ' impressions'}}</div>
                      <div>{{formatNumber(story.userCount) + ' users'}}</div>
                    </div>
                    <div class="newsCoverageSectionStoryArticles" v-if="globalEnvironmentStoriesDisplay[index]">
                      <div v-for="(article, index1) in story.articles" class="newsCoverageSectionStoryArticle">
                        <div class="mb-0">
                          <v-radio-group light v-model="globalEnvironmentStoriesSelection[index]" column class="mt-0">
                            <v-radio :value="article.title" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article.title}}</div>
                            </v-radio>
                            <v-radio :value="article.description" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article.description}}</div>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionStoryDelete">
                    <v-btn text flat icon @click="deleteStoryConfirmation = true; selectedStory = ['globalEnvironmentStories', index, 'globalEnvironmentStoriesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                    <v-btn text flat icon @click="displayContent('globalEnvironmentStoriesDisplay', index)" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon class="newsCoverageSectionStoryExpand" :class="globalEnvironmentStoriesDisplay[index] ? 'newsCoverageSectionStoryExpandRotate' : ''">fas fa-chevron-down</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionStorySources">
                  <div v-for="(article, index2) in story.articles" :key="index2" style="padding-right: 3px;">
                    <a :href="article.url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article.domain)}}<span v-if="index2 !== story.articles.length - 1">,</span></a>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="saudiEnvironmentStories.length > 0">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- SAUDI:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicSaudiStoriesConfirmation = true; selectedTopic = 'Environment'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(story, index) in saudiEnvironmentStories" :key="index">
                <div class="newsCoverageSectionStoryContainer">
                  <div class="newsCoverageSectionStory">
                    <v-radio-group light v-model="saudiEnvironmentStoriesSelection[index]" column class="mt-0">
                      <v-radio :value="story.title + '.'" color="secondary">
                        <div slot="label" class="secondary--text body-2">{{story.title + '.'}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(story.articleCount) + ' articles'}}</div>
                      <div>{{formatNumber(story.domainCount) + ' sources'}}</div>
                      <div>{{formatNumber(story.facebookComments) + ' Facebook comments'}}</div>
                      <div>{{formatNumber(story.facebookReactions) + ' Facebook reactions'}}</div>
                      <div>{{formatNumber(story.facebookShares) + ' Facebook shares'}}</div>
                      <div>{{formatNumber(story.tweetCount) + ' tweets'}}</div>
                      <div>{{formatNumber(story.impressionCount) + ' impressions'}}</div>
                      <div>{{formatNumber(story.userCount) + ' users'}}</div>
                    </div>
                    <div class="newsCoverageSectionStoryArticles" v-if="saudiEnvironmentStoriesDisplay[index]">
                      <div v-for="(article, index1) in story.articles" class="newsCoverageSectionStoryArticle">
                        <div class="mb-0">
                          <v-radio-group light v-model="saudiEnvironmentStoriesSelection[index]" column class="mt-0">
                            <v-radio :value="article.title" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article.title}}</div>
                            </v-radio>
                            <v-radio :value="article.description" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article.description}}</div>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionStoryDelete">
                    <v-btn text flat icon @click="deleteStoryConfirmation = true; selectedStory = ['saudiEnvironmentStories', index, 'saudiEnvironmentStoriesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                    <v-btn text flat icon @click="displayContent('saudiEnvironmentStoriesDisplay', index)" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon class="newsCoverageSectionStoryExpand" :class="saudiEnvironmentStoriesDisplay[index] ? 'newsCoverageSectionStoryExpandRotate' : ''">fas fa-chevron-down</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionStorySources">
                  <div v-for="(article, index2) in story.articles" :key="index2" style="padding-right: 3px;">
                    <a :href="article.url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article.domain)}}<span v-if="index2 !== story.articles.length - 1">,</span></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newsCoverageSection" v-if="globalEnvironmentArticles.length > 0 || saudiEnvironmentArticles.length > 0" :class="globalEnvironmentStories.length > 0 || saudiEnvironmentStories.length > 0 ? 'mt-2' : ''">
          <div class="newsCoverageTopicHeader">
            <div class="subtitle-2 newsCoverageTopicHeaderTitle">- Articles:</div>
            <div class="newsCoverageTopicHeaderBtn">
              <v-btn text flat icon @click="deleteTopicArticlesConfirmation = true; selectedTopic = 'Environment'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
            </div>
          </div>
          <div class="newsCoverageSectionArticles">
            <div v-if="globalEnvironmentArticles.length > 0" :class="saudiEnvironmentArticles.length > 0 ? 'mb-2' : ''">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- GLOBAL:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicGlobalArticlesConfirmation = true; selectedTopic = 'Environment'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(article, index) in globalEnvironmentArticles" :key="index">
                <div class="newsCoverageSectionArticleContainer">
                  <div class="newsCoverageSectionArticle">
                    <v-radio-group hide-details light v-model="globalEnvironmentArticlesSelection[index]" column class="mt-0">
                      <v-radio :value="article._title" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article._title}}</div>
                      </v-radio>
                      <v-radio :value="article._description" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article._description}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(article._tweeted_count) + ' tweets'}}</div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionArticleDelete">
                    <v-btn text flat icon @click="deleteArticleConfirmation = true; selectedArticle = ['globalEnvironmentArticles', index, 'globalEnvironmentArticlesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionArticleSource">
                  <a :href="article._url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article._domain)}}</a>
                </div>
              </div>
            </div>
            <div v-if="saudiEnvironmentArticles.length > 0">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- SAUDI:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicSaudiArticlesConfirmation = true; selectedTopic = 'Environment'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(article, index) in saudiEnvironmentArticles" :key="index">
                <div class="newsCoverageSectionArticleContainer">
                  <div class="newsCoverageSectionArticle">
                    <v-radio-group hide-details light v-model="saudiEnvironmentArticlesSelection[index]" column class="mt-0">
                      <v-radio :value="article._title" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article._title}}</div>
                      </v-radio>
                      <v-radio :value="article._description" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article._description}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(article._tweeted_count) + ' tweets'}}</div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionArticleDelete">
                    <v-btn text flat icon @click="deleteArticleConfirmation = true; selectedArticle = ['saudiEnvironmentArticles', index, 'saudiEnvironmentArticlesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionArticleSource">
                  <a :href="article._url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article._domain)}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="newsCoverage pt-2 mb-3" v-if="globalSportsStories.length > 0 || saudiSportsStories.length > 0 || globalSportsArticles.length > 0 || saudiSportsArticles.length > 0">
        <div class="newsCoverageTopicHeader">
          <div class="subtitle-1 newsCoverageTopicHeaderTitle">- SPORTS:</div>
          <div class="newsCoverageTopicHeaderBtn">
            <v-btn text flat icon @click="deleteTopicConfirmation = true; selectedTopic = 'Sports'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
          </div>
        </div>
        <div class="newsCoverageSection" v-if="globalSportsStories.length > 0 || saudiSportsStories.length > 0">
          <div class="newsCoverageTopicHeader">
            <div class="subtitle-2 newsCoverageTopicHeaderTitle">- Stories:</div>
            <div class="newsCoverageTopicHeaderBtn">
              <v-btn text flat icon @click="deleteTopicStoriesConfirmation = true; selectedTopic = 'Sports'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
            </div>
          </div>
          <div class="newsCoverageSectionStories">
            <div v-if="globalSportsStories.length > 0" :class="saudiSportsStories.length > 0 ? 'mb-2' : ''">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- GLOBAL:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicGlobalStoriesConfirmation = true; selectedTopic = 'Sports'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(story, index) in globalSportsStories" :key="index">
                <div class="newsCoverageSectionStoryContainer">
                  <div class="newsCoverageSectionStory">
                    <v-radio-group light v-model="globalSportsStoriesSelection[index]" column class="mt-0">
                      <v-radio :value="story.title + '.'" color="secondary">
                        <div slot="label" class="secondary--text body-2">{{story.title + '.'}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(story.articleCount) + ' articles'}}</div>
                      <div>{{formatNumber(story.domainCount) + ' sources'}}</div>
                      <div>{{formatNumber(story.facebookComments) + ' Facebook comments'}}</div>
                      <div>{{formatNumber(story.facebookReactions) + ' Facebook reactions'}}</div>
                      <div>{{formatNumber(story.facebookShares) + ' Facebook shares'}}</div>
                      <div>{{formatNumber(story.tweetCount) + ' tweets'}}</div>
                      <div>{{formatNumber(story.impressionCount) + ' impressions'}}</div>
                      <div>{{formatNumber(story.userCount) + ' users'}}</div>
                    </div>
                    <div class="newsCoverageSectionStoryArticles" v-if="globalSportsStoriesDisplay[index]">
                      <div v-for="(article, index1) in story.articles" class="newsCoverageSectionStoryArticle">
                        <div class="mb-0">
                          <v-radio-group light v-model="globalSportsStoriesSelection[index]" column class="mt-0">
                            <v-radio :value="article.title" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article.title}}</div>
                            </v-radio>
                            <v-radio :value="article.description" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article.description}}</div>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionStoryDelete">
                    <v-btn text flat icon @click="deleteStoryConfirmation = true; selectedStory = ['globalSportsStories', index, 'globalSportsStoriesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                    <v-btn text flat icon @click="displayContent('globalSportsStoriesDisplay', index)" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon class="newsCoverageSectionStoryExpand" :class="globalSportsStoriesDisplay[index] ? 'newsCoverageSectionStoryExpandRotate' : ''">fas fa-chevron-down</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionStorySources">
                  <div v-for="(article, index2) in story.articles" :key="index2" style="padding-right: 3px;">
                    <a :href="article.url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article.domain)}}<span v-if="index2 !== story.articles.length - 1">,</span></a>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="saudiSportsStories.length > 0">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- SAUDI:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicSaudiStoriesConfirmation = true; selectedTopic = 'Sports'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(story, index) in saudiSportsStories" :key="index">
                <div class="newsCoverageSectionStoryContainer">
                  <div class="newsCoverageSectionStory">
                    <v-radio-group light v-model="saudiSportsStoriesSelection[index]" column class="mt-0">
                      <v-radio :value="story.title + '.'" color="secondary">
                        <div slot="label" class="secondary--text body-2">{{story.title + '.'}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(story.articleCount) + ' articles'}}</div>
                      <div>{{formatNumber(story.domainCount) + ' sources'}}</div>
                      <div>{{formatNumber(story.facebookComments) + ' Facebook comments'}}</div>
                      <div>{{formatNumber(story.facebookReactions) + ' Facebook reactions'}}</div>
                      <div>{{formatNumber(story.facebookShares) + ' Facebook shares'}}</div>
                      <div>{{formatNumber(story.tweetCount) + ' tweets'}}</div>
                      <div>{{formatNumber(story.impressionCount) + ' impressions'}}</div>
                      <div>{{formatNumber(story.userCount) + ' users'}}</div>
                    </div>
                    <div class="newsCoverageSectionStoryArticles" v-if="saudiSportsStoriesDisplay[index]">
                      <div v-for="(article, index1) in story.articles" class="newsCoverageSectionStoryArticle">
                        <div class="mb-0">
                          <v-radio-group light v-model="saudiSportsStoriesSelection[index]" column class="mt-0">
                            <v-radio :value="article.title" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article.title}}</div>
                            </v-radio>
                            <v-radio :value="article.description" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article.description}}</div>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionStoryDelete">
                    <v-btn text flat icon @click="deleteStoryConfirmation = true; selectedStory = ['saudiSportsStories', index, 'saudiSportsStoriesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                    <v-btn text flat icon @click="displayContent('saudiSportsStoriesDisplay', index)" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon class="newsCoverageSectionStoryExpand" :class="saudiSportsStoriesDisplay[index] ? 'newsCoverageSectionStoryExpandRotate' : ''">fas fa-chevron-down</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionStorySources">
                  <div v-for="(article, index2) in story.articles" :key="index2" style="padding-right: 3px;">
                    <a :href="article.url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article.domain)}}<span v-if="index2 !== story.articles.length - 1">,</span></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newsCoverageSection" v-if="globalSportsArticles.length > 0 || saudiSportsArticles.length > 0" :class="globalSportsStories.length > 0 || saudiSportsStories.length > 0 ? 'mt-2' : ''">
          <div class="newsCoverageTopicHeader">
            <div class="subtitle-2 newsCoverageTopicHeaderTitle">- Articles:</div>
            <div class="newsCoverageTopicHeaderBtn">
              <v-btn text flat icon @click="deleteTopicArticlesConfirmation = true; selectedTopic = 'Sports'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
            </div>
          </div>
          <div class="newsCoverageSectionArticles">
            <div v-if="globalSportsArticles.length > 0" :class="saudiSportsArticles.length > 0 ? 'mb-2' : ''">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- GLOBAL:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicGlobalArticlesConfirmation = true; selectedTopic = 'Sports'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(article, index) in globalSportsArticles" :key="index">
                <div class="newsCoverageSectionArticleContainer">
                  <div class="newsCoverageSectionArticle">
                    <v-radio-group hide-details light v-model="globalSportsArticlesSelection[index]" column class="mt-0">
                      <v-radio :value="article._title" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article._title}}</div>
                      </v-radio>
                      <v-radio :value="article._description" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article._description}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(article._tweeted_count) + ' tweets'}}</div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionArticleDelete">
                    <v-btn text flat icon @click="deleteArticleConfirmation = true; selectedArticle = ['globalSportsArticles', index, 'globalSportsArticlesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionArticleSource">
                  <a :href="article._url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article._domain)}}</a>
                </div>
              </div>
            </div>
            <div v-if="saudiSportsArticles.length > 0">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- SAUDI:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicSaudiArticlesConfirmation = true; selectedTopic = 'Sports'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(article, index) in saudiSportsArticles" :key="index">
                <div class="newsCoverageSectionArticleContainer">
                  <div class="newsCoverageSectionArticle">
                    <v-radio-group hide-details light v-model="saudiSportsArticlesSelection[index]" column class="mt-0">
                      <v-radio :value="article._title" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article._title}}</div>
                      </v-radio>
                      <v-radio :value="article._description" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article._description}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(article._tweeted_count) + ' tweets'}}</div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionArticleDelete">
                    <v-btn text flat icon @click="deleteArticleConfirmation = true; selectedArticle = ['saudiSportsArticles', index, 'saudiSportsArticlesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionArticleSource">
                  <a :href="article._url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article._domain)}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="newsCoverage pt-2 mb-3" v-if="globalArtsStories.length > 0 || saudiArtsStories.length > 0 || globalArtsArticles.length > 0 || saudiArtsArticles.length > 0">
        <div class="newsCoverageTopicHeader">
          <div class="subtitle-1 newsCoverageTopicHeaderTitle">- ARTS:</div>
          <div class="newsCoverageTopicHeaderBtn">
            <v-btn text flat icon @click="deleteTopicConfirmation = true; selectedTopic = 'Arts'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
          </div>
        </div>
        <div class="newsCoverageSection" v-if="globalArtsStories.length > 0 || saudiArtsStories.length > 0">
          <div class="newsCoverageTopicHeader">
            <div class="subtitle-2 newsCoverageTopicHeaderTitle">- Stories:</div>
            <div class="newsCoverageTopicHeaderBtn">
              <v-btn text flat icon @click="deleteTopicStoriesConfirmation = true; selectedTopic = 'Arts'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
            </div>
          </div>
          <div class="newsCoverageSectionStories">
            <div v-if="globalArtsStories.length > 0" :class="saudiArtsStories.length > 0 ? 'mb-2' : ''">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- GLOBAL:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicGlobalStoriesConfirmation = true; selectedTopic = 'Arts'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(story, index) in globalArtsStories" :key="index">
                <div class="newsCoverageSectionStoryContainer">
                  <div class="newsCoverageSectionStory">
                    <v-radio-group light v-model="globalArtsStoriesSelection[index]" column class="mt-0">
                      <v-radio :value="story.title + '.'" color="secondary">
                        <div slot="label" class="secondary--text body-2">{{story.title + '.'}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(story.articleCount) + ' articles'}}</div>
                      <div>{{formatNumber(story.domainCount) + ' sources'}}</div>
                      <div>{{formatNumber(story.facebookComments) + ' Facebook comments'}}</div>
                      <div>{{formatNumber(story.facebookReactions) + ' Facebook reactions'}}</div>
                      <div>{{formatNumber(story.facebookShares) + ' Facebook shares'}}</div>
                      <div>{{formatNumber(story.tweetCount) + ' tweets'}}</div>
                      <div>{{formatNumber(story.impressionCount) + ' impressions'}}</div>
                      <div>{{formatNumber(story.userCount) + ' users'}}</div>
                    </div>
                    <div class="newsCoverageSectionStoryArticles" v-if="globalArtsStoriesDisplay[index]">
                      <div v-for="(article, index1) in story.articles" class="newsCoverageSectionStoryArticle">
                        <div class="mb-0">
                          <v-radio-group light v-model="globalArtsStoriesSelection[index]" column class="mt-0">
                            <v-radio :value="article.title" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article.title}}</div>
                            </v-radio>
                            <v-radio :value="article.description" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article.description}}</div>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionStoryDelete">
                    <v-btn text flat icon @click="deleteStoryConfirmation = true; selectedStory = ['globalArtsStories', index, 'globalArtsStoriesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                    <v-btn text flat icon @click="displayContent('globalArtsStoriesDisplay', index)" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon class="newsCoverageSectionStoryExpand" :class="globalArtsStoriesDisplay[index] ? 'newsCoverageSectionStoryExpandRotate' : ''">fas fa-chevron-down</v-icon></v-btn>
                </div>
                <div class="newsCoverageSectionStorySources">
                  <div v-for="(article, index2) in story.articles" :key="index2" style="padding-right: 3px;">
                    <a :href="article.url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article.domain)}}<span v-if="index2 !== story.articles.length - 1">,</span></a>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="saudiArtsStories.length > 0">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- SAUDI:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicSaudiStoriesConfirmation = true; selectedTopic = 'Arts'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(story, index) in saudiArtsStories" :key="index">
                <div class="newsCoverageSectionStoryContainer">
                  <div class="newsCoverageSectionStory">
                    <v-radio-group light v-model="saudiArtsStoriesSelection[index]" column class="mt-0">
                      <v-radio :value="story.title + '.'" color="secondary">
                        <div slot="label" class="secondary--text body-2">{{story.title + '.'}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(story.articleCount) + ' articles'}}</div>
                      <div>{{formatNumber(story.domainCount) + ' sources'}}</div>
                      <div>{{formatNumber(story.facebookComments) + ' Facebook comments'}}</div>
                      <div>{{formatNumber(story.facebookReactions) + ' Facebook reactions'}}</div>
                      <div>{{formatNumber(story.facebookShares) + ' Facebook shares'}}</div>
                      <div>{{formatNumber(story.tweetCount) + ' tweets'}}</div>
                      <div>{{formatNumber(story.impressionCount) + ' impressions'}}</div>
                      <div>{{formatNumber(story.userCount) + ' users'}}</div>
                    </div>
                    <div class="newsCoverageSectionStoryArticles" v-if="saudiArtsStoriesDisplay[index]">
                      <div v-for="(article, index1) in story.articles" class="newsCoverageSectionStoryArticle">
                        <div class="mb-0">
                          <v-radio-group light v-model="saudiArtsStoriesSelection[index]" column class="mt-0">
                            <v-radio :value="article.title" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article.title}}</div>
                            </v-radio>
                            <v-radio :value="article.description" color="secondary">
                              <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article.description}}</div>
                            </v-radio>
                          </v-radio-group>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionStoryDelete">
                    <v-btn text flat icon @click="deleteStoryConfirmation = true; selectedStory = ['saudiArtsStories', index, 'saudiArtsStoriesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                    <v-btn text flat icon @click="displayContent('saudiArtsStoriesDisplay', index)" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon class="newsCoverageSectionStoryExpand" :class="saudiArtsStoriesDisplay[index] ? 'newsCoverageSectionStoryExpandRotate' : ''">fas fa-chevron-down</v-icon></v-btn>
                </div>
                <div class="newsCoverageSectionStorySources">
                  <div v-for="(article, index2) in story.articles" :key="index2" style="padding-right: 3px;">
                    <a :href="article.url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article.domain)}}<span v-if="index2 !== story.articles.length - 1">,</span></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="newsCoverageSection" v-if="globalArtsArticles.length > 0 || saudiArtsArticles.length > 0" :class="globalArtsStories.length > 0 || saudiArtsStories.length > 0 ? 'mt-2' : ''">
          <div class="newsCoverageTopicHeader">
            <div class="subtitle-2 newsCoverageTopicHeaderTitle">- Articles:</div>
            <div class="newsCoverageTopicHeaderBtn">
              <v-btn text flat icon @click="deleteTopicArticlesConfirmation = true; selectedTopic = 'Arts'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
            </div>
          </div>
          <div class="newsCoverageSectionArticles">
            <div v-if="globalArtsArticles.length > 0" :class="saudiArtsArticles.length > 0 ? 'mb-2' : ''">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- GLOBAL:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicGlobalArticlesConfirmation = true; selectedTopic = 'Arts'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(article, index) in globalArtsArticles" :key="index">
                <div class="newsCoverageSectionArticleContainer">
                  <div class="newsCoverageSectionArticle">
                    <v-radio-group hide-details light v-model="globalArtsArticlesSelection[index]" column class="mt-0">
                      <v-radio :value="article._title" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article._title}}</div>
                      </v-radio>
                      <v-radio :value="article._description" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article._description}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(article._tweeted_count) + ' tweets'}}</div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionArticleDelete">
                    <v-btn text flat icon @click="deleteArticleConfirmation = true; selectedArticle = ['globalArtsArticles', index, 'globalArtsArticlesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionArticleSource">
                  <a :href="article._url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article._domain)}}</a>
                </div>
              </div>
            </div>
            <div v-if="saudiArtsArticles.length > 0">
              <div class="newsCoverageTopicHeader">
                <div class="subtitle-2 newsCoverageTopicHeaderTitle">- SAUDI:</div>
                <div class="newsCoverageTopicHeaderBtn">
                  <v-btn text flat icon @click="deleteTopicSaudiArticlesConfirmation = true; selectedTopic = 'Arts'" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                </div>
              </div>
              <div class="body-2" style="margin-left: 35px;" v-for="(article, index) in saudiArtsArticles" :key="index">
                <div class="newsCoverageSectionArticleContainer">
                  <div class="newsCoverageSectionArticle">
                    <v-radio-group hide-details light v-model="saudiArtsArticlesSelection[index]" column class="mt-0">
                      <v-radio :value="article._title" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Title: </b>{{article._title}}</div>
                      </v-radio>
                      <v-radio :value="article._description" color="secondary">
                        <div slot="label" class="secondary--text body-2"><b>Description: </b>{{article._description}}</div>
                      </v-radio>
                    </v-radio-group>
                    <div class="newsCoverageSectionStoryDetails">
                      <div>{{formatNumber(article._tweeted_count) + ' tweets'}}</div>
                    </div>
                  </div>
                  <div class="newsCoverageSectionArticleDelete">
                    <v-btn text flat icon @click="deleteArticleConfirmation = true; selectedArticle = ['saudiArtsArticles', index, 'saudiArtsArticlesSelection']" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
                  </div>
                </div>
                <div class="newsCoverageSectionArticleSource">
                  <a :href="article._url" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{sld(article._domain)}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <v-dialog v-model="deleteTopicConfirmation" width="300">
        <v-card class="secondary">
          <v-card-title class="headline">Delete topic?</v-card-title>
          <v-card-text>
            <div style="width: 100%; display: flex; justify-content: center">
              <v-btn flat small @click="deleteTopic">Confirm</v-btn>
              <v-btn flat small @click="deleteTopicConfirmation = false">Cancel</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteTopicStoriesConfirmation" width="300">
        <v-card class="secondary">
          <v-card-title class="headline">Delete all stories for topic?</v-card-title>
          <v-card-text>
            <div style="width: 100%; display: flex; justify-content: center">
              <v-btn flat small @click="deleteTopicStories">Confirm</v-btn>
              <v-btn flat small @click="deleteTopicStoriesConfirmation = false">Cancel</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteTopicGlobalStoriesConfirmation" width="300">
        <v-card class="secondary">
          <v-card-title class="headline">Delete all global stories for topic?</v-card-title>
          <v-card-text>
            <div style="width: 100%; display: flex; justify-content: center">
              <v-btn flat small @click="deleteTopicGlobalStories">Confirm</v-btn>
              <v-btn flat small @click="deleteTopicGlobalStoriesConfirmation = false">Cancel</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteTopicSaudiStoriesConfirmation" width="300">
        <v-card class="secondary">
          <v-card-title class="headline">Delete all saudi stories for topic?</v-card-title>
          <v-card-text>
            <div style="width: 100%; display: flex; justify-content: center">
              <v-btn flat small @click="deleteTopicSaudiStories">Confirm</v-btn>
              <v-btn flat small @click="deleteTopicSaudiStoriesConfirmation = false">Cancel</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteTopicGlobalArticlesConfirmation" width="300">
        <v-card class="secondary">
          <v-card-title class="headline">Delete all global articles for topic?</v-card-title>
          <v-card-text>
            <div style="width: 100%; display: flex; justify-content: center">
              <v-btn flat small @click="deleteTopicGlobalArticles">Confirm</v-btn>
              <v-btn flat small @click="deleteTopicGlobalArticlesConfirmation = false">Cancel</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteTopicSaudiArticlesConfirmation" width="300">
        <v-card class="secondary">
          <v-card-title class="headline">Delete all saudi articles for topic?</v-card-title>
          <v-card-text>
            <div style="width: 100%; display: flex; justify-content: center">
              <v-btn flat small @click="deleteTopicSaudiArticles">Confirm</v-btn>
              <v-btn flat small @click="deleteTopicSaudiArticlesConfirmation = false">Cancel</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteTopicArticlesConfirmation" width="300">
        <v-card class="secondary">
          <v-card-title class="headline">Delete all articles for topic?</v-card-title>
          <v-card-text>
            <div style="width: 100%; display: flex; justify-content: center">
              <v-btn flat small @click="deleteTopicArticles">Confirm</v-btn>
              <v-btn flat small @click="deleteTopicArticlesConfirmation = false">Cancel</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteStoryConfirmation" width="300">
        <v-card class="secondary">
          <v-card-title class="headline">Delete story?</v-card-title>
          <v-card-text>
            <div style="width: 100%; display: flex; justify-content: center">
              <v-btn flat small @click="deleteStory">Confirm</v-btn>
              <v-btn flat small @click="deleteStoryConfirmation = false">Cancel</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteArticleConfirmation" width="300">
        <v-card class="secondary">
          <v-card-title class="headline">Delete article?</v-card-title>
          <v-card-text>
            <div style="width: 100%; display: flex; justify-content: center">
              <v-btn flat small @click="deleteArticle">Confirm</v-btn>
              <v-btn flat small @click="deleteArticleConfirmation = false">Cancel</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <br/>
    <div class="highlight secondary--text pa-3" v-if="amaalaCounters || amaalaTweets">
      <div class="newsCoverageHeader title" style="display: flex; align-items: center"><v-icon color="secondary" class="mr-2">fab fa-twitter</v-icon><div style="text-decoration: underline">Amaala Twitter Coverage:</div></div>
      <div class="newsCoverage pt-2 mb-3" v-if="amaalaCounters">
        <div class="subtitle-1 mb-2" style="display: flex; align-items: center; justify-content: flex-start; width: 250px;" v-if="amaalaCounters._impression_count">
          <div class="mr-2" style="flex: none">- Impressions: </div>
          <v-text-field hide-details light class="mt-0 pt-0" v-model="amaalaCounters._impression_count"></v-text-field>
        </div>
        <div class="subtitle-1 mb-2" style="display: flex; align-items: center; justify-content: flex-start; width: 250px;" v-if="amaalaCounters._tweet_count">
          <div class="mr-2" style="flex: none">- Mentions: </div>
          <v-text-field hide-details light class="mt-0 pt-0" v-model="amaalaCounters._tweet_count"></v-text-field>
        </div>
        <div class="subtitle-1 mb-2" v-if="amaalaCounters._twitter_countries && amaalaCounters._twitter_countries && amaalaCounters._twitter_countries.length > 0">{{'- Top Location: ' + amaalaCounters._twitter_countries[0]._country_name + ' - ' + formatNumber(amaalaCounters._twitter_countries[0]._tweet_count) + ' Tweets'}}</div>
        <div class="subtitle-1 mb-2" v-if="amaalaCounters._twitter_sentiment">- Sentiment:</div>
        <div class="subtitle-1 mb-2" style="margin-left: 35px;" v-if="amaalaCounters._twitter_sentiment && amaalaCounters._twitter_sentiment.find(item => { return item._sentiment === 1 })">{{'- Positive: ' + formatNumber(amaalaCounters._twitter_sentiment.find(item => { return item._sentiment === 1 })._tweet_count) + ' Tweets'}}</div>
        <div class="subtitle-1 mb-2" style="margin-left: 35px;" v-if="amaalaCounters._twitter_sentiment && amaalaCounters._twitter_sentiment.find(item => { return item._sentiment === 0 })">{{'- Neutral: ' + formatNumber(amaalaCounters._twitter_sentiment.find(item => { return item._sentiment === 0 })._tweet_count) + ' Tweets'}}</div>
        <div class="subtitle-1 mb-2" style="margin-left: 35px;" v-if="amaalaCounters._twitter_sentiment && amaalaCounters._twitter_sentiment.find(item => { return item._sentiment === -1 })">{{'- Negative: ' + formatNumber(amaalaCounters._twitter_sentiment.find(item => { return item._sentiment === -1 })._tweet_count) + ' Tweets'}}</div>
      </div>
      <div class="subtitle-1 newsCoverage pt-2 mb-3" v-if="amaalaTweets && amaalaTweets.length > 0">
        <div>- Top 5 Tweets:</div>
        <div v-for="(tweet, index) in amaalaTweets" :key="index" style="display: flex;">
          <div style="width: calc(100% - 60px)">
            <div class="amaalaTweet">
              <a :href="'https://twitter.com/' + tweet._user_name + '/status/' + tweet._twitter_id" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{tweet._text}}</a>
            </div>
            <div class="amaalaTweetData">
              <div>{{formatNumber(tweet._retweet_count_latest) + ' Retweets'}}</div>
              <div class="amaalaTweetDivider"></div>
              <div>{{formatNumber(tweet._favorite_count_latest) + ' Favorites'}}</div>
              <div class="amaalaTweetDivider"></div>
              <div>
                <a :href="'https://twitter.com/' + tweet._user_name" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{'@' + tweet._user_name }}</a>
              </div>
              <div class="amaalaTweetDivider"></div>
              <div>{{formatNumber(tweet._user_followers_count) + ' Followers'}}</div>
              <div class="amaalaTweetDivider"></div>
              <div>{{tweet._created_at}}</div>
            </div>
          </div>
          <div class="topTweetsDeleteBtn">
            <v-btn text flat icon @click="deleteTweetConfirmation = true; selectedTweet = index" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
          </div>
        </div>
      </div>
      <v-dialog v-model="deleteTweetConfirmation" width="300">
        <v-card class="secondary">
          <v-card-title class="headline">Delete tweet?</v-card-title>
          <v-card-text>
            <div style="width: 100%; display: flex; justify-content: center">
              <v-btn flat small @click="deleteAmaalaTweet">Confirm</v-btn>
              <v-btn flat small @click="deleteTweetConfirmation = false">Cancel</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <br/>
    <div class="highlight secondary--text pa-3" v-if="wiwCounters || wiwTweets">
      <div class="newsCoverageHeader title" style="display: flex; align-items: center"><v-icon color="secondary" class="mr-2">fab fa-twitter</v-icon><div style="text-decoration: underline">#WhereInTheWorld Twitter Coverage:</div></div>
      <div class="newsCoverage pt-2 mb-3" v-if="wiwCounters">
        <div class="subtitle-1 mb-2" style="display: flex; align-items: center; justify-content: flex-start; width: 250px;" v-if="wiwCounters._impression_count">
          <div class="mr-2" style="flex: none">- Impressions: </div>
          <v-text-field hide-details light class="mt-0 pt-0" v-model="wiwCounters._impression_count"></v-text-field>
        </div>
        <div class="subtitle-1 mb-2" style="display: flex; align-items: center; justify-content: flex-start; width: 250px;" v-if="wiwCounters._tweet_count">
          <div class="mr-2" style="flex: none">- Mentions: </div>
          <v-text-field hide-details light class="mt-0 pt-0" v-model="wiwCounters._tweet_count"></v-text-field>
        </div>
        <div class="subtitle-1 mb-2" v-if="wiwCounters._twitter_countries && wiwCounters._twitter_countries && wiwCounters._twitter_countries.length > 0">{{'- Top Location: ' + wiwCounters._twitter_countries[0]._country_name + ' - ' + formatNumber(wiwCounters._twitter_countries[0]._tweet_count) + ' Tweets'}}</div>
        <div class="subtitle-1 mb-2" v-if="wiwCounters._twitter_sentiment">- Sentiment:</div>
        <div class="subtitle-1 mb-2" style="margin-left: 35px;" v-if="wiwCounters._twitter_sentiment && wiwCounters._twitter_sentiment.find(item => { return item._sentiment === 1 })">{{'- Positive: ' + formatNumber(wiwCounters._twitter_sentiment.find(item => { return item._sentiment === 1 })._tweet_count) + ' Tweets'}}</div>
        <div class="subtitle-1 mb-2" style="margin-left: 35px;" v-if="wiwCounters._twitter_sentiment && wiwCounters._twitter_sentiment.find(item => { return item._sentiment === 0 })">{{'- Neutral: ' + formatNumber(wiwCounters._twitter_sentiment.find(item => { return item._sentiment === 0 })._tweet_count) + ' Tweets'}}</div>
        <div class="subtitle-1 mb-2" style="margin-left: 35px;" v-if="wiwCounters._twitter_sentiment && wiwCounters._twitter_sentiment.find(item => { return item._sentiment === -1 })">{{'- Negative: ' + formatNumber(wiwCounters._twitter_sentiment.find(item => { return item._sentiment === -1 })._tweet_count) + ' Tweets'}}</div>
      </div>
      <div class="subtitle-1 newsCoverage pt-2 mb-3" v-if="wiwTweets && wiwTweets.length > 0">
        <div>- Top 5 Tweets:</div>
        <div v-for="(tweet, index) in wiwTweets" :key="index" style="display: flex;">
          <div style="width: calc(100% - 60px)">
            <div class="amaalaTweet">
              <a :href="'https://twitter.com/' + tweet._user_name + '/status/' + tweet._twitter_id" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{tweet._text}}</a>
            </div>
            <div class="amaalaTweetData">
              <div>{{formatNumber(tweet._retweet_count_latest) + ' Retweets'}}</div>
              <div class="amaalaTweetDivider"></div>
              <div>{{formatNumber(tweet._favorite_count_latest) + ' Favorites'}}</div>
              <div class="amaalaTweetDivider"></div>
              <div>
                <a :href="'https://twitter.com/' + tweet._user_name" target="_blank" class="secondary--text" style="text-transform: uppercase;">{{'@' + tweet._user_name }}</a>
              </div>
              <div class="amaalaTweetDivider"></div>
              <div>{{formatNumber(tweet._user_followers_count) + ' Followers'}}</div>
              <div class="amaalaTweetDivider"></div>
              <div>{{tweet._created_at}}</div>
            </div>
          </div>
          <div class="topTweetsDeleteBtn">
            <v-btn text flat icon @click="deleteTweetConfirmation = true; selectedTweet = index" :ripple="false" color="secondary" class="ma-0 pa-0"><v-icon>fas fa-backspace</v-icon></v-btn>
          </div>
        </div>
      </div>
      <v-dialog v-model="deleteTweetConfirmation" width="300">
        <v-card class="secondary">
          <v-card-title class="headline">Delete tweet?</v-card-title>
          <v-card-text>
            <div style="width: 100%; display: flex; justify-content: center">
              <v-btn flat small @click="deleteWiwTweet">Confirm</v-btn>
              <v-btn flat small @click="deleteTweetConfirmation = false">Cancel</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>

    <v-toolbar class="highlight secondary--text pa-2 mt-4" v-if="atLeastOneStory || atLeastOneArticle">
      <v-toolbar-title>Amaala Daily Digest</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-text-field light label="From Date" style="margin: 5px;" v-model="fromDate" :disabled="loading || exportLoading"></v-text-field>
        <v-text-field light label="To Date" style="margin: 5px;" v-model="toDate" :disabled="loading || exportLoading"></v-text-field>
        <v-btn flat light @click="generateReport" :loading="loading" :disabled="exportLoading">Generate Report</v-btn>
        <v-btn flat light @click="exportPptx" :disabled="loading || !reportExists" :loading="exportLoading">Export PPTX</v-btn>
      </v-toolbar-items>
    </v-toolbar>
  </v-container>
</template>

<style>
  .newsCoverage, .newsCoverageSection, .newsCoverageSectionStories, .newsCoverageSectionStoryArticles, .newsCoverageSectionArticles{
    margin-left: 35px;
  }
  .newsCoverageSectionStoryArticle{
    display: flex;
  }
  .newsCoverage .v-input__slot{
    margin-bottom: 0 !important;
  }
  .newsCoverageSectionStoryDelete, .newsCoverageSectionArticleDelete, .topTweetsDeleteBtn, .newsCoverageTopicHeaderBtn{
    width: 60px;
  }
  .newsCoverageSectionStoryDelete, .newsCoverageSectionStoryContainer, .newsCoverageSectionArticleContainer, .newsCoverageTopicHeader{
    display: flex;
  }
  .newsCoverageSectionStory, .newsCoverageSectionArticle, .newsCoverageTopicHeaderTitle{
    width: calc(100% - 60px);
  }
  .newsCoverageTopicHeader{
    align-items: center;
  }
  .newsCoverageSectionStoryDelete button:hover:before, .newsCoverageSectionArticleDelete button:hover:before, .topTweetsDeleteBtn button:hover:before, .newsCoverageTopicHeaderBtn button:hover:before{
    background-color: transparent !important;
  }
  .newsCoverageSectionStorySources, .newsCoverageSectionArticleSource{
    display: flex;
    margin-left: 35px;
    flex-wrap: wrap;
    margin-bottom: 30px;
  }
  .newsCoverageSectionArticleSource{
    margin-bottom: 10px;
  }
  .newsCoverageSectionStoryExpand{
    transition: all ease 300ms;
    transform: rotate(0deg);
  }
  .newsCoverageSectionStoryExpandRotate{
    transform: rotate(180deg);
  }
  .amaalaTweetDivider{
    height: 100%;
    width: 0px;
    border-left: 1px solid #212121;
  }
  .amaalaTweetData{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 60px);
    margin-left: 45px;
    margin-bottom: 25px;
  }
  .amaalaTweet{
    margin-left: 45px;
    margin-bottom: 10px;
  }
  .amaalaTweet:before{
    content: '- ';
    position: absolute;
    margin-left: -10px;
  }
  .newsCoverageSectionStoryDetails{
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    padding-left: 35px;
  }
  .newsCoverageSectionStoryDetails div{
    margin-right: 10px;
  }
</style>

<script>
import psl from 'psl'
import PptxGenJS from 'pptxgenjs'
import { mapMutations } from 'vuex'
import { formatDateTime, getUTCDate } from '@/helpers/formatters'
import numeral from 'numeral'

export default {
  data () {
    return {
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      loading: false,
      exportLoading: false,
      globalPoliticsStories: [],
      globalTourismStories: [],
      globalBusinessStories: [],
      globalTechStories: [],
      globalSocialStories: [],
      globalEnvironmentStories: [],
      globalSportsStories: [],
      globalArtsStories: [],
      globalPoliticsArticles: [],
      globalTourismArticles: [],
      globalBusinessArticles: [],
      globalTechArticles: [],
      globalSocialArticles: [],
      globalEnvironmentArticles: [],
      globalSportsArticles: [],
      globalArtsArticles: [],
      saudiPoliticsStories: [],
      saudiTourismStories: [],
      saudiBusinessStories: [],
      saudiTechStories: [],
      saudiSocialStories: [],
      saudiEnvironmentStories: [],
      saudiSportsStories: [],
      saudiArtsStories: [],
      saudiPoliticsArticles: [],
      saudiTourismArticles: [],
      saudiBusinessArticles: [],
      saudiTechArticles: [],
      saudiSocialArticles: [],
      saudiEnvironmentArticles: [],
      saudiSportsArticles: [],
      saudiArtsArticles: [],
      fromDate: '',
      toDate: '',
      globalPoliticsStoriesSelection: [],
      globalTourismStoriesSelection: [],
      globalBusinessStoriesSelection: [],
      globalTechStoriesSelection: [],
      globalSocialStoriesSelection: [],
      globalEnvironmentStoriesSelection: [],
      globalSportsStoriesSelection: [],
      globalArtsStoriesSelection: [],
      globalPoliticsArticlesSelection: [],
      globalTourismArticlesSelection: [],
      globalBusinessArticlesSelection: [],
      globalTechArticlesSelection: [],
      globalSocialArticlesSelection: [],
      globalEnvironmentArticlesSelection: [],
      globalSportsArticlesSelection: [],
      globalArtsArticlesSelection: [],
      saudiPoliticsStoriesSelection: [],
      saudiTourismStoriesSelection: [],
      saudiBusinessStoriesSelection: [],
      saudiTechStoriesSelection: [],
      saudiSocialStoriesSelection: [],
      saudiEnvironmentStoriesSelection: [],
      saudiSportsStoriesSelection: [],
      saudiArtsStoriesSelection: [],
      saudiPoliticsArticlesSelection: [],
      saudiTourismArticlesSelection: [],
      saudiBusinessArticlesSelection: [],
      saudiTechArticlesSelection: [],
      saudiSocialArticlesSelection: [],
      saudiEnvironmentArticlesSelection: [],
      saudiSportsArticlesSelection: [],
      saudiArtsArticlesSelection: [],
      globalPoliticsStoriesDisplay: [],
      globalTourismStoriesDisplay: [],
      globalBusinessStoriesDisplay: [],
      globalTechStoriesDisplay: [],
      globalSocialStoriesDisplay: [],
      globalEnvironmentStoriesDisplay: [],
      globalSportsStoriesDisplay: [],
      globalArtsStoriesDisplay: [],
      saudiPoliticsStoriesDisplay: [],
      saudiTourismStoriesDisplay: [],
      saudiBusinessStoriesDisplay: [],
      saudiTechStoriesDisplay: [],
      saudiSocialStoriesDisplay: [],
      saudiEnvironmentStoriesDisplay: [],
      saudiSportsStoriesDisplay: [],
      saudiArtsStoriesDisplay: [],
      amaalaCounters: null,
      amaalaTweets: null,
      amaalaTwitterStats: [],
      wiwCounters: null,
      wiwTweets: null,
      wiwTwitterStats: [],
      selectedTopic: '',
      deleteTopicStoriesConfirmation: false,
      deleteTopicArticlesConfirmation: false,
      deleteTopicGlobalStoriesConfirmation: false,
      deleteTopicSaudiStoriesConfirmation: false,
      deleteTopicGlobalArticlesConfirmation: false,
      deleteTopicSaudiArticlesConfirmation: false,
      deleteTopicConfirmation: false,
      selectedStory: [],
      deleteStoryConfirmation: false,
      selectedArticle: [],
      deleteArticleConfirmation: false,
      selectedTweet: [],
      deleteTweetConfirmation: false,
      slide: null,
      pptx: null,
      slideLines: 0,
      reportExists: false,
      currentMaster: 'MASTER_SLIDE_COVER'
    }
  },
  created () {
    var date = new Date()
    var year = date.getFullYear()
    var month = date.getMonth()
    var today = date.getDate()
    var yesterday = this.addDays(date, -1)
    this.toDate = year + '-' + ((month + 1) < 10 ? '0' + (month + 1) : (month + 1)) + '-' + today + ' 08:00:00'
    this.fromDate = yesterday.getFullYear() + '-' + ((yesterday.getMonth() + 1) < 10 ? '0' + (yesterday.getMonth() + 1) : (yesterday.getMonth() + 1)) + '-' + yesterday.getDate() + ' 08:00:00'
  },
  computed: {
    atLeastOneStory () {
      return this.globalPoliticsStories.length > 0 || this.globalTourismStories.length > 0 || this.globalBusinessStories.length > 0 || this.globalTechStories.length > 0 || this.globalSocialStories.length > 0 || this.globalEnvironmentStories.length > 0 || this.globalSportsStories.length > 0 || this.globalArtsStories.length > 0 || this.saudiPoliticsStories.length > 0 || this.saudiTourismStories.length > 0 || this.saudiBusinessStories.length > 0 || this.saudiTechStories.length > 0 || this.saudiSocialStories.length > 0 || this.saudiEnvironmentStories.length > 0 || this.saudiSportsStories.length > 0 || this.saudiArtsStories.length > 0
    },
    atLeastOneArticle () {
      return this.globalPoliticsArticles.length > 0 || this.globalTourismArticles.length > 0 || this.globalBusinessArticles.length > 0 || this.globalTechArticles.length > 0 || this.globalSocialArticles.length > 0 || this.globalEnvironmentArticles.length > 0 || this.globalSportsArticles.length > 0 || this.globalArtsArticles.length > 0 || this.saudiPoliticsArticles.length > 0 || this.saudiTourismArticles.length > 0 || this.saudiBusinessArticles.length > 0 || this.saudiTechArticles.length > 0 || this.saudiSocialArticles.length > 0 || this.saudiEnvironmentArticles.length > 0 || this.saudiSportsArticles.length > 0 || this.saudiArtsArticles.length > 0
    }
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    ...mapMutations('loading', ['showLoading', 'hideLoading']),
    addDays: function (date, days) {
      var result = new Date(date)
      result.setDate(result.getDate() + days)
      return result
    },
    formatNumber: function (value) {
      return Number(value) > 999 ? numeral(Number(value)).format('0.0a').toUpperCase() : value
    },
    displayContent (dataArray, index) {
      this.$set(this[dataArray], index, !this[dataArray][index])
    },
    sld (domain) {
      var parsedDomain = psl.parse(domain)
      return parsedDomain.sld
    },
    deleteStory () {
      this[this.selectedStory[0]].splice(this.selectedStory[1], 1)
      this[this.selectedStory[2]].splice(this.selectedStory[1], 1)
      this.selectedStory = []
      this.deleteStoryConfirmation = false
    },
    deleteTopic () {
      this['global' + this.selectedTopic + 'Stories'] = []
      this['global' + this.selectedTopic + 'StoriesSelection'] = []
      this['saudi' + this.selectedTopic + 'Stories'] = []
      this['saudi' + this.selectedTopic + 'StoriesSelection'] = []
      this['global' + this.selectedTopic + 'Articles'] = []
      this['global' + this.selectedTopic + 'ArticlesSelection'] = []
      this['saudi' + this.selectedTopic + 'Articles'] = []
      this['saudi' + this.selectedTopic + 'ArticlesSelection'] = []
      this.deleteTopicConfirmation = false
    },
    deleteTopicStories () {
      this['global' + this.selectedTopic + 'Stories'] = []
      this['global' + this.selectedTopic + 'StoriesSelection'] = []
      this['saudi' + this.selectedTopic + 'Stories'] = []
      this['saudi' + this.selectedTopic + 'StoriesSelection'] = []
      this.deleteTopicStoriesConfirmation = false
    },
    deleteTopicGlobalStories () {
      this['global' + this.selectedTopic + 'Stories'] = []
      this['global' + this.selectedTopic + 'StoriesSelection'] = []
      this.deleteTopicGlobalStoriesConfirmation = false
    },
    deleteTopicSaudiStories () {
      this['saudi' + this.selectedTopic + 'Stories'] = []
      this['saudi' + this.selectedTopic + 'StoriesSelection'] = []
      this.deleteTopicSaudiStoriesConfirmation = false
    },
    deleteTopicArticles () {
      this['global' + this.selectedTopic + 'Articles'] = []
      this['global' + this.selectedTopic + 'ArticlesSelection'] = []
      this['saudi' + this.selectedTopic + 'Articles'] = []
      this['saudi' + this.selectedTopic + 'ArticlesSelection'] = []
      this.deleteTopicArticlesConfirmation = false
    },
    deleteTopicGlobalArticles () {
      this['global' + this.selectedTopic + 'Articles'] = []
      this['global' + this.selectedTopic + 'ArticlesSelection'] = []
      this.deleteTopicGlobalArticlesConfirmation = false
    },
    deleteTopicSaudiArticles () {
      this['saudi' + this.selectedTopic + 'Articles'] = []
      this['saudi' + this.selectedTopic + 'ArticlesSelection'] = []
      this.deleteTopicSaudiArticlesConfirmation = false
    },
    deleteArticle () {
      this[this.selectedArticle[0]].splice(this.selectedArticle[1], 1)
      this[this.selectedArticle[2]].splice(this.selectedArticle[1], 1)
      this.selectedArticle = []
      this.deleteArticleConfirmation = false
    },
    deleteAmaalaTweet () {
      this.amaalaTweets.splice(this.selectedTweet, 1)
      this.selectedTweet = []
      this.deleteTweetConfirmation = false
    },
    deleteWiwTweet () {
      this.wiwTweets.splice(this.selectedTweet, 1)
      this.selectedTweet = []
      this.deleteTweetConfirmation = false
    },
    clear: function () {
      this.globalPoliticsStories = []
      this.globalTourismStories = []
      this.globalBusinessStories = []
      this.globalTechStories = []
      this.globalSocialStories = []
      this.globalEnvironmentStories = []
      this.globalSportsStories = []
      this.globalArtsStories = []
      this.saudiPoliticsStories = []
      this.saudiTourismStories = []
      this.saudiBusinessStories = []
      this.saudiTechStories = []
      this.saudiSocialStories = []
      this.saudiEnvironmentStories = []
      this.saudiSportsStories = []
      this.saudiArtsStories = []
      this.globalPoliticsStoriesSelection = []
      this.globalTourismStoriesSelection = []
      this.globalBusinessStoriesSelection = []
      this.globalTechStoriesSelection = []
      this.globalSocialStoriesSelection = []
      this.globalEnvironmentStoriesSelection = []
      this.globalSportsStoriesSelection = []
      this.globalArtsStoriesSelection = []
      this.saudiPoliticsStoriesSelection = []
      this.saudiTourismStoriesSelection = []
      this.saudiBusinessStoriesSelection = []
      this.saudiTechStoriesSelection = []
      this.saudiSocialStoriesSelection = []
      this.saudiEnvironmentStoriesSelection = []
      this.saudiSportsStoriesSelection = []
      this.saudiArtsStoriesSelection = []
      this.globalPoliticsArticles = []
      this.globalTourismArticles = []
      this.globalBusinessArticles = []
      this.globalTechArticles = []
      this.globalSocialArticles = []
      this.globalEnvironmentArticles = []
      this.globalSportsArticles = []
      this.globalArtsArticles = []
      this.saudiPoliticsArticles = []
      this.saudiTourismArticles = []
      this.saudiBusinessArticles = []
      this.saudiTechArticles = []
      this.saudiSocialArticles = []
      this.saudiEnvironmentArticles = []
      this.saudiSportsArticles = []
      this.saudiArtsArticles = []
      this.globalPoliticsArticlesSelection = []
      this.globalTourismArticlesSelection = []
      this.globalBusinessArticlesSelection = []
      this.globalTechArticlesSelection = []
      this.globalSocialArticlesSelection = []
      this.globalEnvironmentArticlesSelection = []
      this.globalSportsArticlesSelection = []
      this.globalArtsArticlesSelection = []
      this.saudiPoliticsArticlesSelection = []
      this.saudiTourismArticlesSelection = []
      this.saudiBusinessArticlesSelection = []
      this.saudiTechArticlesSelection = []
      this.saudiSocialArticlesSelection = []
      this.saudiEnvironmentArticlesSelection = []
      this.saudiSportsArticlesSelection = []
      this.saudiArtsArticlesSelection = []
      this.globalPoliticsStoriesDisplay = []
      this.globalTourismStoriesDisplay = []
      this.globalBusinessStoriesDisplay = []
      this.globalTechStoriesDisplay = []
      this.globalSocialStoriesDisplay = []
      this.globalEnvironmentStoriesDisplay = []
      this.globalSportsStoriesDisplay = []
      this.globalArtsStoriesDisplay = []
      this.saudiPoliticsStoriesDisplay = []
      this.saudiTourismStoriesDisplay = []
      this.saudiBusinessStoriesDisplay = []
      this.saudiTechStoriesDisplay = []
      this.saudiSocialStoriesDisplay = []
      this.saudiEnvironmentStoriesDisplay = []
      this.saudiSportsStoriesDisplay = []
      this.saudiArtsStoriesDisplay = []
      this.selectedTopic = []
      this.deleteTopicConfirmation = false
      this.deleteTopicStoriesConfirmation = false
      this.deleteTopicArticlesConfirmation = false
      this.deleteTopicGlobalStoriesConfirmation = false
      this.deleteTopicSaudiStoriesConfirmation = false
      this.deleteTopicGlobalArticlesConfirmation = false
      this.deleteTopicSaudiArticlesConfirmation = false
      this.selectedStory = []
      this.deleteStoryConfirmation = false
      this.selectedArticle = []
      this.amaalaCounters = null
      this.amaalaTweets = null
      this.amaalaTwitterStats = []
      this.wiwCounters = null
      this.wiwTweets = null
      this.wiwTwitterStats = []
      this.deleteArticleConfirmation = false
      this.slide = null
      this.pptx = null
      this.slideLines = 0
      this.currentMaster = 'MASTER_SLIDE_COVER'
    },
    async generateReport () {
      this.loading = true
      this.clear()
      this.amaalaCounters = await this.getCounters('d7fb1573-2ebb-4028-a2b8-1bd494e312f5')
      this.amaalaTweets = await this.getTweets('d7fb1573-2ebb-4028-a2b8-1bd494e312f5')
      this.amaalaTwitterStats = await this.getTweetStats('d7fb1573-2ebb-4028-a2b8-1bd494e312f5')
      this.wiwCounters = await this.getCounters('702257fe-e952-483b-831b-af3497bab246')
      this.wiwTweets = await this.getTweets('702257fe-e952-483b-831b-af3497bab246')
      this.wiwTwitterStats = await this.getTweetStats('702257fe-e952-483b-831b-af3497bab246')
      await this.getGlobalStories()
      await this.getGlobalArticles()
      await this.getSaudiStories()
      await this.getSaudiArticles()
      this.reportExists = true
      this.loading = false
    },
    async getGlobalStories () {
      var i = 0
      var ids = []
      this.globalPoliticsStories = await this.getGlobalStoriesByTopic('POLITICS')
      for (i = 0; i < this.globalPoliticsStories.length; i++) {
        ids.push(this.globalPoliticsStories[i].id)
        this.globalPoliticsStoriesSelection.push(this.globalPoliticsStories[i].title + '.')
        this.globalPoliticsStoriesDisplay.push(false)
      }
      this.globalTourismStories = (await this.getGlobalStoriesByTopic('TOURISM')).filter(story => !ids.includes(story.id))
      for (i = 0; i < this.globalTourismStories.length; i++) {
        ids.push(this.globalTourismStories[i].id)
        this.globalTourismStoriesSelection.push(this.globalTourismStories[i].title + '.')
        this.globalTourismStoriesDisplay.push(false)
      }
      this.globalBusinessStories = (await this.getGlobalStoriesByTopic('BUSINESS,FINANCE,ECONOMY')).filter(story => !ids.includes(story.id))
      for (i = 0; i < this.globalBusinessStories.length; i++) {
        ids.push(this.globalBusinessStories[i].id)
        this.globalBusinessStoriesSelection.push(this.globalBusinessStories[i].title + '.')
        this.globalBusinessStoriesDisplay.push(false)
      }
      this.globalTechStories = (await this.getGlobalStoriesByTopic('SCIENCE,TECH')).filter(story => !ids.includes(story.id))
      for (i = 0; i < this.globalTechStories.length; i++) {
        ids.push(this.globalTechStories[i].id)
        this.globalTechStoriesSelection.push(this.globalTechStories[i].title + '.')
        this.globalTechStoriesDisplay.push(false)
      }
      this.globalSocialStories = (await this.getGlobalStoriesByTopic('SOCIAL')).filter(story => !ids.includes(story.id))
      for (i = 0; i < this.globalSocialStories.length; i++) {
        ids.push(this.globalSocialStories[i].id)
        this.globalSocialStoriesSelection.push(this.globalSocialStories[i].title + '.')
        this.globalSocialStoriesDisplay.push(false)
      }
      this.globalEnvironmentStories = (await this.getGlobalStoriesByTopic('ENVIRONMENT')).filter(story => !ids.includes(story.id))
      for (i = 0; i < this.globalEnvironmentStories.length; i++) {
        ids.push(this.globalEnvironmentStories[i].id)
        this.globalEnvironmentStoriesSelection.push(this.globalEnvironmentStories[i].title + '.')
        this.globalEnvironmentStoriesDisplay.push(false)
      }
      this.globalSportsStories = (await this.getGlobalStoriesByTopic('SPORTS')).filter(story => !ids.includes(story.id))
      for (i = 0; i < this.globalSportsStories.length; i++) {
        ids.push(this.globalSportsStories[i].id)
        this.globalSportsStoriesSelection.push(this.globalSportsStories[i].title + '.')
        this.globalSportsStoriesDisplay.push(false)
      }
      this.globalArtsStories = (await this.getGlobalStoriesByTopic('ARTS,CULTURE,ENTERTAINMENT')).filter(story => !ids.includes(story.id))
      for (i = 0; i < this.globalArtsStories.length; i++) {
        ids.push(this.globalArtsStories[i].id)
        this.globalArtsStoriesSelection.push(this.globalArtsStories[i].title + '.')
        this.globalArtsStoriesDisplay.push(false)
      }
    },
    async getGlobalArticles () {
      var i = 0
      var ids = []
      this.globalPoliticsArticles = await this.getGlobalArticlesByTopic('POLITICS')
      for (i = 0; i < this.globalPoliticsArticles.length; i++) {
        ids.push(this.globalPoliticsArticles[i]._id)
        this.globalPoliticsArticlesSelection.push(this.globalPoliticsArticles[i]._title)
      }
      this.globalTourismArticles = (await this.getGlobalArticlesByTopic('TOURISM')).filter(article => !ids.includes(article._id))
      for (i = 0; i < this.globalTourismArticles.length; i++) {
        ids.push(this.globalTourismArticles[i]._id)
        this.globalTourismArticlesSelection.push(this.globalTourismArticles[i]._title)
      }
      this.globalBusinessArticles = (await this.getGlobalArticlesByTopic('BUSINESS,FINANCE,ECONOMY')).filter(article => !ids.includes(article._id))
      for (i = 0; i < this.globalBusinessArticles.length; i++) {
        ids.push(this.globalBusinessArticles[i]._id)
        this.globalBusinessArticlesSelection.push(this.globalBusinessArticles[i]._title)
      }
      this.globalTechArticles = (await this.getGlobalArticlesByTopic('SCIENCE,TECH')).filter(article => !ids.includes(article._id))
      for (i = 0; i < this.globalTechArticles.length; i++) {
        ids.push(this.globalTechArticles[i]._id)
        this.globalTechArticlesSelection.push(this.globalTechArticles[i]._title)
      }
      this.globalSocialArticles = (await this.getGlobalArticlesByTopic('SOCIAL')).filter(article => !ids.includes(article._id))
      for (i = 0; i < this.globalSocialArticles.length; i++) {
        ids.push(this.globalSocialArticles[i]._id)
        this.globalSocialArticlesSelection.push(this.globalSocialArticles[i]._title)
      }
      this.globalEnvironmentArticles = (await this.getGlobalArticlesByTopic('ENVIRONMENT')).filter(article => !ids.includes(article._id))
      for (i = 0; i < this.globalEnvironmentArticles.length; i++) {
        ids.push(this.globalEnvironmentArticles[i]._id)
        this.globalEnvironmentArticlesSelection.push(this.globalEnvironmentArticles[i]._title)
      }
      this.globalSportsArticles = (await this.getGlobalArticlesByTopic('SPORTS')).filter(article => !ids.includes(article._id))
      for (i = 0; i < this.globalSportsArticles.length; i++) {
        ids.push(this.globalSportsArticles[i]._id)
        this.globalSportsArticlesSelection.push(this.globalSportsArticles[i]._title)
      }
      this.globalArtsArticles = (await this.getGlobalArticlesByTopic('ARTS,CULTURE,ENTERTAINMENT')).filter(article => !ids.includes(article._id))
      for (i = 0; i < this.globalArtsArticles.length; i++) {
        ids.push(this.globalArtsArticles[i]._id)
        this.globalArtsArticlesSelection.push(this.globalArtsArticles[i]._title)
      }
    },
    async getSaudiStories () {
      var i = 0
      var ids = []
      this.saudiPoliticsStories = await this.getSaudiStoriesByTopic('POLITICS')
      for (i = 0; i < this.saudiPoliticsStories.length; i++) {
        ids.push(this.saudiPoliticsStories[i].id)
        this.saudiPoliticsStoriesSelection.push(this.saudiPoliticsStories[i].title + '.')
        this.saudiPoliticsStoriesDisplay.push(false)
      }
      this.saudiTourismStories = (await this.getSaudiStoriesByTopic('TOURISM')).filter(story => !ids.includes(story.id))
      for (i = 0; i < this.saudiTourismStories.length; i++) {
        ids.push(this.saudiTourismStories[i].id)
        this.saudiTourismStoriesSelection.push(this.saudiTourismStories[i].title + '.')
        this.saudiTourismStoriesDisplay.push(false)
      }
      this.saudiBusinessStories = (await this.getSaudiStoriesByTopic('BUSINESS,FINANCE,ECONOMY')).filter(story => !ids.includes(story.id))
      for (i = 0; i < this.saudiBusinessStories.length; i++) {
        ids.push(this.saudiBusinessStories[i].id)
        this.saudiBusinessStoriesSelection.push(this.saudiBusinessStories[i].title + '.')
        this.saudiBusinessStoriesDisplay.push(false)
      }
      this.saudiTechStories = (await this.getSaudiStoriesByTopic('SCIENCE,TECH')).filter(story => !ids.includes(story.id))
      for (i = 0; i < this.saudiTechStories.length; i++) {
        ids.push(this.saudiTechStories[i].id)
        this.saudiTechStoriesSelection.push(this.saudiTechStories[i].title + '.')
        this.saudiTechStoriesDisplay.push(false)
      }
      this.saudiSocialStories = (await this.getSaudiStoriesByTopic('SOCIAL')).filter(story => !ids.includes(story.id))
      for (i = 0; i < this.saudiSocialStories.length; i++) {
        ids.push(this.saudiSocialStories[i].id)
        this.saudiSocialStoriesSelection.push(this.saudiSocialStories[i].title + '.')
        this.saudiSocialStoriesDisplay.push(false)
      }
      this.saudiEnvironmentStories = (await this.getSaudiStoriesByTopic('ENVIRONMENT')).filter(story => !ids.includes(story.id))
      for (i = 0; i < this.saudiEnvironmentStories.length; i++) {
        ids.push(this.saudiEnvironmentStories[i].id)
        this.saudiEnvironmentStoriesSelection.push(this.saudiEnvironmentStories[i].title + '.')
        this.saudiEnvironmentStoriesDisplay.push(false)
      }
      this.saudiSportsStories = (await this.getSaudiStoriesByTopic('SPORTS')).filter(story => !ids.includes(story.id))
      for (i = 0; i < this.saudiSportsStories.length; i++) {
        ids.push(this.saudiSportsStories[i].id)
        this.saudiSportsStoriesSelection.push(this.saudiSportsStories[i].title + '.')
        this.saudiSportsStoriesDisplay.push(false)
      }
      this.saudiArtsStories = (await this.getSaudiStoriesByTopic('ARTS,CULTURE,ENTERTAINMENT')).filter(story => !ids.includes(story.id))
      for (i = 0; i < this.saudiArtsStories.length; i++) {
        ids.push(this.saudiArtsStories[i].id)
        this.saudiArtsStoriesSelection.push(this.saudiArtsStories[i].title + '.')
        this.saudiArtsStoriesDisplay.push(false)
      }
    },
    async getSaudiArticles () {
      var i = 0
      var ids = []
      this.saudiPoliticsArticles = await this.getSaudiArticlesByTopic('POLITICS')
      for (i = 0; i < this.saudiPoliticsArticles.length; i++) {
        ids.push(this.saudiPoliticsArticles[i]._id)
        this.saudiPoliticsArticlesSelection.push(this.saudiPoliticsArticles[i]._title)
      }
      this.saudiTourismArticles = (await this.getSaudiArticlesByTopic('TOURISM')).filter(article => !ids.includes(article._id))
      for (i = 0; i < this.saudiTourismArticles.length; i++) {
        ids.push(this.saudiTourismArticles[i]._id)
        this.saudiTourismArticlesSelection.push(this.saudiTourismArticles[i]._title)
      }
      this.saudiBusinessArticles = (await this.getSaudiArticlesByTopic('BUSINESS,FINANCE,ECONOMY')).filter(article => !ids.includes(article._id))
      for (i = 0; i < this.saudiBusinessArticles.length; i++) {
        ids.push(this.saudiBusinessArticles[i]._id)
        this.saudiBusinessArticlesSelection.push(this.saudiBusinessArticles[i]._title)
      }
      this.saudiTechArticles = (await this.getSaudiArticlesByTopic('SCIENCE,TECH')).filter(article => !ids.includes(article._id))
      for (i = 0; i < this.saudiTechArticles.length; i++) {
        ids.push(this.saudiTechArticles[i]._id)
        this.saudiTechArticlesSelection.push(this.saudiTechArticles[i]._title)
      }
      this.saudiSocialArticles = (await this.getSaudiArticlesByTopic('SOCIAL')).filter(article => !ids.includes(article._id))
      for (i = 0; i < this.saudiSocialArticles.length; i++) {
        ids.push(this.saudiSocialArticles[i]._id)
        this.saudiSocialArticlesSelection.push(this.saudiSocialArticles[i]._title)
      }
      this.saudiEnvironmentArticles = (await this.getSaudiArticlesByTopic('ENVIRONMENT')).filter(article => !ids.includes(article._id))
      for (i = 0; i < this.saudiEnvironmentArticles.length; i++) {
        ids.push(this.saudiEnvironmentArticles[i]._id)
        this.saudiEnvironmentArticlesSelection.push(this.saudiEnvironmentArticles[i]._title)
      }
      this.saudiSportsArticles = (await this.getSaudiArticlesByTopic('SPORTS')).filter(article => !ids.includes(article._id))
      for (i = 0; i < this.saudiSportsArticles.length; i++) {
        ids.push(this.saudiSportsArticles[i]._id)
        this.saudiSportsArticlesSelection.push(this.saudiSportsArticles[i]._title)
      }
      this.saudiArtsArticles = (await this.getSaudiArticlesByTopic('ARTS,CULTURE,ENTERTAINMENT')).filter(article => !ids.includes(article._id))
      for (i = 0; i < this.saudiArtsArticles.length; i++) {
        ids.push(this.saudiArtsArticles[i]._id)
        this.saudiArtsArticlesSelection.push(this.saudiArtsArticles[i]._title)
      }
    },
    async getGlobalStoriesByTopic (topic) {
      try {
        var query = '?' + 'projectUuid=' + '0c13d039-1a64-45de-bd73-560b2f7524b0'
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&sortBy=' + '_tweet_count'
        query += '&order=' + 'desc'
        query += '&pageSize=' + '5'
        query += '&pageNumber=' + '1'
        query += '&text=' + 'saudi'
        query += '&text=' + 'سعودي'
        query += '&topic=' + topic
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()

        let response = await this.$store.dispatch('getCustomReportsStories', query)
        if (response.data.status === 'SUCCESS') {
          return response.data.payload
        } else {
          return []
        }
      } catch (err) {
        console.log(err)
        this.notify({message: 'Something went wrong. Please try again.', show: true})
      }
    },
    async getSaudiStoriesByTopic (topic) {
      try {
        var query = '?' + 'projectUuid=' + 'f0544d20-f2d6-4c27-bb83-78cb6f1a2751'
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&sortBy=' + '_tweet_count'
        query += '&order=' + 'desc'
        query += '&pageSize=' + '5'
        query += '&pageNumber=' + '1'
        query += '&topic=' + topic
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()

        let response = await this.$store.dispatch('getCustomReportsStories', query)
        if (response.data.status === 'SUCCESS') {
          return response.data.payload
        } else {
          return []
        }
      } catch (err) {
        console.log(err)
        this.notify({message: 'Something went wrong. Please try again.', show: true})
      }
    },
    async getGlobalArticlesByTopic (topic) {
      try {
        let results = []

        let query = '?' + 'projectUuid=' + '0c13d039-1a64-45de-bd73-560b2f7524b0'
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&sortBy=' + '_tweeted_count'
        query += '&order=' + 'desc'
        query += '&pageSize=' + '5'
        query += '&pageNumber=' + '1'
        query += '&text=' + 'saudi'
        query += '&text=' + 'سعودي'
        query += '&topic=' + topic
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()

        let response = await this.$store.dispatch('getCustomReportsArticlesWithoutStories', query)
        if (response.data.status === 'SUCCESS') {
          results = response.data.payload
        }

        return results
      } catch (err) {
        console.log(err)
        this.notify({message: 'Something went wrong. Please try again.', show: true})
        return []
      }
    },
    async getSaudiArticlesByTopic (topic) {
      try {
        let results = []

        let query = '?' + 'projectUuid=' + 'f0544d20-f2d6-4c27-bb83-78cb6f1a2751'
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&sortBy=' + '_tweeted_count'
        query += '&order=' + 'desc'
        query += '&pageSize=' + '5'
        query += '&pageNumber=' + '1'
        query += '&topic=' + topic
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()

        let response = await this.$store.dispatch('getCustomReportsArticlesWithoutStories', query)
        if (response.data.status === 'SUCCESS') {
          results = response.data.payload
        }

        return results
      } catch (err) {
        console.log(err)
        this.notify({message: 'Something went wrong. Please try again.', show: true})
        return []
      }
    },
    async getCounters (projectUuid) {
      try {
        let results = {}

        let query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        let response = await this.$store.dispatch('getCustomReportsTweetsCount', query)
        if (response.data.status === 'SUCCESS') {
          results._tweet_count = response.data.payload[0]._tweet_count
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsTweetsImpressionsCount', query)
        if (response.data.status === 'SUCCESS') {
          results._impression_count = response.data.payload[0]._impression_count
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&interval=' + 'day'
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsTweetsVolume', query)
        if (response.data.status === 'SUCCESS') {
          results._tweets_volume = response.data.payload
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsTwitterUsersCount', query)
        if (response.data.status === 'SUCCESS') {
          results._user_count = response.data.payload[0]._user_count
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsArticlesCount', query)
        if (response.data.status === 'SUCCESS') {
          results._article_count = response.data.payload[0]._article_count
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsStoriesStats', query)
        if (response.data.status === 'SUCCESS') {
          results._stories_stats = response.data.payload
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsTweetsCountBySentiment', query)
        if (response.data.status === 'SUCCESS') {
          results._twitter_sentiment = response.data.payload
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&pageSize=' + '5'
        query += '&pageNumber=' + '1'
        query += '&sortBy=' + '_tweet_count'
        query += '&order=' + 'desc'
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsTweetsCountByCountry', query)
        if (response.data.status === 'SUCCESS') {
          results._twitter_countries = response.data.payload
        }

        query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()
        response = await this.$store.dispatch('getCustomReportsArticlesCountBySentiment', query)
        if (response.data.status === 'SUCCESS') {
          results._news_sentiment = response.data.payload
        }

        return results
      } catch (err) {
        console.log(err)
        this.notify({message: 'Something went wrong. Please try again.', show: true})
        return {}
      }
    },
    async getTweets (projectUuid) {
      try {
        let results = []

        let query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&sortBy=' + '_twitter_interactions_latest'
        query += '&tweetType=' + 'TWEET'
        query += '&order=' + 'desc'
        query += '&pageSize=' + '5'
        query += '&pageNumber=' + '1'
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()

        let response = await this.$store.dispatch('getCustomReportsTweets', query)
        if (response.data.status === 'SUCCESS') {
          results = response.data.payload
        }
        return results
      } catch (err) {
        console.log(err)
        this.notify({message: 'Something went wrong. Please try again.', show: true})
        return []
      }
    },
    async getTweetStats (projectUuid) {
      try {
        let results = []

        let query = '?' + 'projectUuid=' + projectUuid
        query += '&fromDate=' + getUTCDate(this.fromDate)
        query += '&toDate=' + getUTCDate(this.toDate)
        query += '&isDetected=' + 'true'
        query += '&no_cache=' + (new Date()).getTime()

        let response = await this.$store.dispatch('getCustomReportsTweetsTypesCount', query)
        if (response.data.status === 'SUCCESS') {
          results = response.data.payload
        }
        return results
      } catch (err) {
        console.log(err)
        this.notify({message: 'Something went wrong. Please try again.', show: true})
        return []
      }
    },
    exportPptx: function () {
      this.exportLoading = true
      this.pptx = new PptxGenJS()
      this.pptx.setLayout({ name: 'A4', width: 9, height: 14 })
      this.currentMaster = 'MASTER_SLIDE_COVER'
      var from = new Date(this.fromDate).getDate()
      var fromMonth = new Date(this.fromDate).getMonth()
      var to = new Date(this.toDate).getDate()
      var toMonth = new Date(this.toDate).getMonth()
      var dateRange = this.months[fromMonth] + ' ' + from
      if (fromMonth !== toMonth) {
        dateRange = dateRange + ' - ' + this.months[toMonth] + ' ' + to
      } else if (from !== to) {
        dateRange = dateRange + ' - ' + to
      }

      this.pptx.defineSlideMaster({
        title: 'MASTER_SLIDE_COVER',
        bkgd: '046A32',
        objects: [
          { 'text': { text: 'AMAALA Listening and Monitoring', options: { x: 1.06, y: 5.68, w: 4.04, h: 1, color: 'FFFFFF', bold: false, fontFace: 'Libre Baskerville', fontSize: 13 } } },
          { 'text': { text: 'Daily Digest', options: { x: 1.06, y: 6.57, w: 4.04, h: 1, color: 'FFFFFF', bold: false, fontFace: 'Proxima Nova', fontSize: 30 } } },
          { 'text': { text: formatDateTime(this.fromDate) + ' - ' + formatDateTime(this.toDate), options: { x: 1.06, y: 7.31, w: 4.04, h: 1, color: 'FFFFFF', bold: false, fontFace: 'Libre Baskerville', fontSize: 13 } } },
          { 'text': { text: 'Strictly Confidential   |', options: { x: 7.7, y: 13.2, w: 1.3, h: 0.39, color: 'FFFFFF', bold: false, fontFace: 'Proxima Nova', fontSize: 7 } } },
          { 'text': { text: '1', options: { x: 8.7, y: 13.2, w: 0.19, h: 0.39, color: 'FFFFFF', bold: false, fontFace: 'Proxima Nova', fontSize: 7 } } }
        ]
      })

      this.pptx.defineSlideMaster({
        title: 'MASTER_SLIDE_AGENDA',
        bkgd: 'FFFFFF',
        objects: [
          { 'rect': { x: 0.0, y: 0, w: '100%', h: 0.83, fill: 'FFF2CC' } },
          { 'image': { x: 0.23, y: 0.11, w: 0.78, h: 0.62, path: '/static/amaala.png' } },
          { 'text': { text: 'The News Shaping the Agenda', options: { align: 'center', x: -0.01, y: 0, w: 9.01, h: 0.83, color: '006A56', bold: true, fontFace: 'Proxima Nova', fontSize: 20 } } },
          { 'text': { text: dateRange, options: { x: 7.49, y: 0, w: 1.52, h: 0.83, color: '006A56', bold: true, fontFace: 'Proxima Nova', fontSize: 12 } } },
          { 'text': { text: 'Daily Monitoring Digest   |', options: { x: 7.5, y: 13.22, w: 1.39, h: 0.39, color: '006A56', bold: false, fontFace: 'Proxima Nova', fontSize: 7 } } },
          { 'image': { x: 0.28, y: 13.02, w: 0.62, h: 0.3, path: '/static/mirum.jpg' } },
          { 'image': { x: 1.05, y: 13.15, w: 1.26, h: 0.18, path: '/static/hks.png' } }
        ],
        slideNumber: { x: 8.7, y: 13.32, w: 0.19, h: 0.39, bullet: false, bold: false, fontSize: 7, color: '006A56', fontFace: 'Proxima Nova', valign: 'middle' }
      })

      this.slide = this.pptx.addNewSlide(this.currentMaster)
      this.slideLines = 1.33
      this.currentMaster = 'MASTER_SLIDE_AGENDA'
      if (this.globalPoliticsStories.length > 0 || this.saudiPoliticsStories.length > 0 || this.globalPoliticsArticles.length > 0 || this.saudiPoliticsArticles.length > 0) {
        this.slide = this.pptx.addNewSlide(this.currentMaster)
        this.slide.addText('Geo-Politics', {x: 0.59, y: this.slideLines, w: 1.88, fontSize: 13, color: '006A56', fontFace: 'Proxima Nova', bold: true})
        this.slideLines = this.slideLines + 0.6
        this.slide.addImage({ path: '/static/pptLine.png', x: 0.33, y: this.slideLines, w: 1.88, h: 0.25 })
        this.slideLines = this.slideLines + 0.5
        this.checkSlideLines()
        this.addStoriesToPptx('globalPoliticsStories', 'globalPoliticsStoriesSelection')
        this.addStoriesToPptx('saudiPoliticsStories', 'saudiPoliticsStoriesSelection')
        this.addArticlesToPptx('globalPoliticsArticles', 'globalPoliticsArticlesSelection')
        this.addArticlesToPptx('saudiPoliticsArticles', 'saudiPoliticsArticlesSelection')
        this.slideLines = this.slideLines + 0.3
        this.checkSlideLines()

        if (this.globalTourismStories.length > 0 || this.saudiTourismStories.length > 0 || this.globalTourismArticles.length > 0 || this.saudiTourismArticles.length > 0) {
          this.slide.addText('Tourism', {x: 0.59, y: this.slideLines, w: 1.88, fontSize: 13, color: '006A56', fontFace: 'Proxima Nova', bold: true})
          this.slideLines = this.slideLines + 0.6
          this.slide.addImage({ path: '/static/pptLine.png', x: 0.33, y: this.slideLines, w: 1.88, h: 0.25 })
          this.slideLines = this.slideLines + 0.5
          this.checkSlideLines()
          this.addStoriesToPptx('globalTourismStories', 'globalTourismStoriesSelection')
          this.addStoriesToPptx('saudiTourismStories', 'saudiTourismStoriesSelection')
          this.addArticlesToPptx('globalTourismArticles', 'globalTourismArticlesSelection')
          this.addArticlesToPptx('saudiTourismArticles', 'saudiTourismArticlesSelection')
          this.slideLines = this.slideLines + 0.3
          this.checkSlideLines()
        }

        if (this.globalBusinessStories.length > 0 || this.saudiBusinessStories.length > 0 || this.globalBusinessArticles.length > 0 || this.saudiBusinessArticles.length > 0) {
          this.slide.addText('Business', {x: 0.59, y: this.slideLines, w: 1.88, fontSize: 13, color: '006A56', fontFace: 'Proxima Nova', bold: true})
          this.slideLines = this.slideLines + 0.6
          this.slide.addImage({ path: '/static/pptLine.png', x: 0.33, y: this.slideLines, w: 1.88, h: 0.25 })
          this.slideLines = this.slideLines + 0.5
          this.checkSlideLines()
          this.addStoriesToPptx('globalBusinessStories', 'globalBusinessStoriesSelection')
          this.addStoriesToPptx('saudiBusinessStories', 'saudiBusinessStoriesSelection')
          this.addArticlesToPptx('globalBusinessArticles', 'globalBusinessArticlesSelection')
          this.addArticlesToPptx('saudiBusinessArticles', 'saudiBusinessArticlesSelection')
          this.slideLines = this.slideLines + 0.3
          this.checkSlideLines()
        }

        if (this.globalTechStories.length > 0 || this.saudiTechStories.length > 0 || this.globalTechArticles.length > 0 || this.saudiTechArticles.length > 0) {
          this.slide.addText('Tech', {x: 0.59, y: this.slideLines, w: 1.88, fontSize: 13, color: '006A56', fontFace: 'Proxima Nova', bold: true})
          this.slideLines = this.slideLines + 0.6
          this.slide.addImage({ path: '/static/pptLine.png', x: 0.33, y: this.slideLines, w: 1.88, h: 0.25 })
          this.slideLines = this.slideLines + 0.5
          this.checkSlideLines()
          this.addStoriesToPptx('globalTechStories', 'globalTechStoriesSelection')
          this.addStoriesToPptx('saudiTechStories', 'saudiTechStoriesSelection')
          this.addArticlesToPptx('globalTechArticles', 'globalTechArticlesSelection')
          this.addArticlesToPptx('saudiTechArticles', 'saudiTechArticlesSelection')
          this.slideLines = this.slideLines + 0.3
          this.checkSlideLines()
        }

        if (this.globalEnvironmentStories.length > 0 || this.saudiEnvironmentStories.length > 0 || this.globalEnvironmentArticles.length > 0 || this.saudiEnvironmentArticles.length > 0) {
          this.slide.addText('Environment', {x: 0.59, y: this.slideLines, w: 1.88, fontSize: 13, color: '006A56', fontFace: 'Proxima Nova', bold: true})
          this.slideLines = this.slideLines + 0.6
          this.slide.addImage({ path: '/static/pptLine.png', x: 0.33, y: this.slideLines, w: 1.88, h: 0.25 })
          this.slideLines = this.slideLines + 0.5
          this.checkSlideLines()
          this.addStoriesToPptx('globalEnvironmentStories', 'globalEnvironmentStoriesSelection')
          this.addStoriesToPptx('saudiEnvironmentStories', 'saudiEnvironmentStoriesSelection')
          this.addArticlesToPptx('globalEnvironmentArticles', 'globalEnvironmentArticlesSelection')
          this.addArticlesToPptx('saudiEnvironmentArticles', 'saudiEnvironmentArticlesSelection')
          this.slideLines = this.slideLines + 0.3
          this.checkSlideLines()
        }

        if (this.globalSportsStories.length > 0 || this.saudiSportsStories.length > 0 || this.globalSportsArticles.length > 0 || this.saudiSportsArticles.length > 0) {
          this.slide.addText('Sports', {x: 0.59, y: this.slideLines, w: 1.88, fontSize: 13, color: '006A56', fontFace: 'Proxima Nova', bold: true})
          this.slideLines = this.slideLines + 0.6
          this.slide.addImage({ path: '/static/pptLine.png', x: 0.33, y: this.slideLines, w: 1.88, h: 0.25 })
          this.slideLines = this.slideLines + 0.5
          this.checkSlideLines()
          this.addStoriesToPptx('globalSportsStories', 'globalSportsStoriesSelection')
          this.addStoriesToPptx('saudiSportsStories', 'saudiSportsStoriesSelection')
          this.addArticlesToPptx('globalSportsArticles', 'globalSportsArticlesSelection')
          this.addArticlesToPptx('saudiSportsArticles', 'saudiSportsArticlesSelection')
          this.slideLines = this.slideLines + 0.3
          this.checkSlideLines()
        }

        if (this.globalArtsStories.length > 0 || this.saudiArtsStories.length > 0 || this.globalArtsArticles.length > 0 || this.saudiArtsArticles.length > 0) {
          this.slide.addText('Arts', {x: 0.59, y: this.slideLines, w: 1.88, fontSize: 13, color: '006A56', fontFace: 'Proxima Nova', bold: true})
          this.slideLines = this.slideLines + 0.6
          this.slide.addImage({ path: '/static/pptLine.png', x: 0.33, y: this.slideLines, w: 1.88, h: 0.25 })
          this.slideLines = this.slideLines + 0.5
          this.checkSlideLines()
          this.addStoriesToPptx('globalArtsStories', 'globalArtsStoriesSelection')
          this.addStoriesToPptx('saudiArtsStories', 'saudiArtsStoriesSelection')
          this.addArticlesToPptx('globalArtsArticles', 'globalArtsArticlesSelection')
          this.addArticlesToPptx('saudiArtsArticles', 'saudiArtsArticlesSelection')
          this.slideLines = this.slideLines + 0.3
          this.checkSlideLines()
        }
      }

      this.pptx.defineSlideMaster({
        title: 'MASTER_SLIDE_TWITTER',
        bkgd: 'FFFFFF',
        objects: [
          { 'rect': { x: 0.0, y: 0, w: '100%', h: 0.83, fill: 'FFF2CC' } },
          { 'image': { x: 0.23, y: 0.11, w: 0.78, h: 0.62, path: '/static/amaala.png' } },
          { 'text': { text: 'AMAALA Specific Mentions', options: { align: 'center', x: -0.01, y: 0, w: 9.01, h: 0.83, color: '006A56', bold: true, fontFace: 'Proxima Nova', fontSize: 20 } } },
          { 'text': { text: dateRange, options: { x: 7.49, y: 0, w: 1.52, h: 0.83, color: '006A56', bold: true, fontFace: 'Proxima Nova', fontSize: 12 } } },
          { 'text': { text: 'Daily Monitoring Digest   |', options: { x: 7.5, y: 13.22, w: 1.39, h: 0.39, color: '006A56', bold: false, fontFace: 'Proxima Nova', fontSize: 7 } } },
          { 'image': { x: 0.28, y: 13.02, w: 0.62, h: 0.3, path: '/static/mirum.jpg' } },
          { 'image': { x: 1.05, y: 13.15, w: 1.26, h: 0.18, path: '/static/hks.png' } }
        ],
        slideNumber: { x: 8.7, y: 13.32, w: 0.19, h: 0.39, bullet: false, bold: false, fontSize: 7, color: '006A56', fontFace: 'Proxima Nova', valign: 'middle' }
      })
      this.currentMaster = 'MASTER_SLIDE_TWITTER'
      this.slide = this.pptx.addNewSlide(this.currentMaster)
      this.slideLines = 1.33

      var ts = 0
      var t = 0
      var tweet = null
      var tweetInfo = null
      var positiveSentiment = null
      var neutralSentiment = null
      var negativeSentiment = null
      var generalSentiment = null
      var counters = null
      if (this.amaalaTweets || this.amaalaCounters || this.amaalaTwitterStats) {
        this.slide.addText('Key Takeaways', {x: 0.5, y: this.slideLines, w: 1.88, fontSize: 13, color: '006A56', fontFace: 'Proxima Nova', bold: true})
        this.slideLines = this.slideLines + 0.6
        this.slide.addImage({ path: '/static/pptLine.png', x: 0.33, y: this.slideLines, w: 1.88, h: 0.25 })
        this.slideLines = this.slideLines + 0.5
        this.checkSlideLines()

        if (this.amaalaCounters) {
          positiveSentiment = this.amaalaCounters._twitter_sentiment.find(item => { return item._sentiment === 1 })
          neutralSentiment = this.amaalaCounters._twitter_sentiment.find(item => { return item._sentiment === 0 })
          negativeSentiment = this.amaalaCounters._twitter_sentiment.find(item => { return item._sentiment === -1 })
          generalSentiment = 'positive'
          if (positiveSentiment) {
            if (neutralSentiment && neutralSentiment._tweet_count > positiveSentiment._tweet_count) {
              generalSentiment = 'neutral'
            }
            if (negativeSentiment && negativeSentiment._tweet_count > positiveSentiment._tweet_count) {
              if (neutralSentiment && neutralSentiment._tweet_count < negativeSentiment._tweet_count) {
                generalSentiment = 'negative'
              }
            }
          } else if (negativeSentiment) {
            generalSentiment = 'negative'
            if (neutralSentiment && neutralSentiment._tweet_count > negativeSentiment._tweet_count) {
              generalSentiment = 'neutral'
            }
          } else {
            generalSentiment = 'neutral'
          }

          counters = 'Between the morning of ' + this.months[fromMonth] + ' ' + from + ' and ' + this.months[toMonth] + ' ' + to + ', the mentions around AMAALA amounted to ' + this.formatNumber(this.amaalaCounters._tweet_count) + ' mentions, collecting about ' + this.formatNumber(this.amaalaCounters._impression_count) + ' impressions on Twitter. The general sentiment was ' + generalSentiment
          if (this.amaalaCounters._twitter_countries.length > 0) {
            counters = counters + ' and the main contributors were from ' + this.amaalaCounters._twitter_countries[0]._country_name
          }
          counters = counters + '.'
          this.slide.addText(counters, {bullet: {code: '25CF'}, bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 0.8, y: this.slideLines, w: 7.85, isTextBox: true, autoFit: true, valign: 'top'})

          this.slideLines = this.slideLines + 0.3 + (0.2 * Math.floor(counters.length / 81))
          this.checkSlideLines()

          if (positiveSentiment || neutralSentiment || negativeSentiment) {
            this.slide.addText('Sentiment:', {bullet: {code: '25CF'}, bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 0.8, y: this.slideLines, w: 7.85, isTextBox: true, autoFit: true, valign: 'top'})
            this.slideLines = this.slideLines + 0.3
            this.checkSlideLines()

            if (positiveSentiment) {
              this.slide.addText('Positive: ' + this.formatNumber(positiveSentiment._tweet_count + ' Tweets'), {bullet: false, bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 1.2, y: this.slideLines, w: 7.85, isTextBox: true, autoFit: true, valign: 'top'})
              this.slideLines = this.slideLines + 0.3
              this.checkSlideLines()
            }

            if (neutralSentiment) {
              this.slide.addText('Neutral: ' + this.formatNumber(neutralSentiment._tweet_count + ' Tweets'), {bullet: false, bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 1.2, y: this.slideLines, w: 7.85, isTextBox: true, autoFit: true, valign: 'top'})
              this.slideLines = this.slideLines + 0.3
              this.checkSlideLines()
            }

            if (negativeSentiment) {
              this.slide.addText('Negative: ' + this.formatNumber(negativeSentiment._tweet_count + ' Tweets'), {bullet: false, bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 1.2, y: this.slideLines, w: 7.85, isTextBox: true, autoFit: true, valign: 'top'})
              this.slideLines = this.slideLines + 0.3
              this.checkSlideLines()
            }
          }
        }

        if (this.amaalaTweets) {
          this.slide.addText('Amaala Top Tweets:', {bullet: {code: '25CF'}, bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 0.8, y: this.slideLines, w: 7.85, isTextBox: true, autoFit: true, valign: 'top'})
          this.slideLines = this.slideLines + 0.3
          this.checkSlideLines()
          for (t = 0; t < this.amaalaTweets.length; t++) {
            tweet = this.amaalaTweets[t]
            while (tweet._text.indexOf('\n') !== -1) {
              tweet._text = tweet._text.replace('\n', ' ')
            }
            this.slide.addText(tweet._text, {bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 1.42, y: this.slideLines, w: 7.1, isTextBox: true, autoFit: true, valign: 'top', bullet: {code: '25CF'}})
            this.slideLines = this.slideLines + 0.3 + (0.2 * Math.floor(this.amaalaTweets[t]._text.length / 81))
            this.checkSlideLines()
            tweetInfo = '- ' + this.formatNumber(tweet._retweet_count_latest) + ' Retweets  - ' + this.formatNumber(tweet._favorite_count_latest) + ' Favorites  - ' + 'Created at: ' + tweet._created_at + '  - User: @' + tweet._user_name + '  - ' + this.formatNumber(tweet._user_followers_count) + ' Followers'
            this.slide.addText(tweetInfo, {bullet: false, bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 1.8, y: this.slideLines, w: 6.6, isTextBox: true, autoFit: true, valign: 'top'})
            this.slideLines = this.slideLines + 0.3 + (0.2 * Math.floor(tweetInfo.length / 81))
            this.checkSlideLines()
            this.slide.addText(
              [{
                text: 'Tweet',
                options: { hyperlink: { url: 'https://twitter.com/' + tweet._user_name + '/status/' + tweet._twitter_id, tooltip: 'Go to tweet' } }
              }],
              {
                bullet: false, bold: true, fontSize: 12, color: '3A3AB9', fontFace: 'Proxima Nova', lineSpacing: 15, x: 0.8, y: this.slideLines, w: 6.6, isTextBox: true, autoFit: true, valign: 'top'
              }
            )
            this.slideLines = this.slideLines + 0.6
            this.checkSlideLines()
          }
        }

        if (this.amaalaTwitterStats.length > 0) {
          for (ts = 0; ts < this.amaalaTwitterStats.length; ts++) {
            this.slide.addText(this.amaalaTwitterStats[ts]._tweet_type + ': ' + this.formatNumber(this.amaalaTwitterStats[ts]._tweet_count), {bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 1.42, y: this.slideLines, w: 7.1, isTextBox: true, autoFit: true, valign: 'top', bullet: {code: '25CF'}})
            this.slideLines = this.slideLines + 0.6
            this.checkSlideLines()
          }
        }
      }

      if (this.wiwTweets || this.wiwCounters || this.wiwTwitterStats) {
        this.slideLines = this.slideLines + 0.5
        this.checkSlideLines()

        if (this.wiwCounters) {
          positiveSentiment = this.wiwCounters._twitter_sentiment.find(item => { return item._sentiment === 1 })
          neutralSentiment = this.wiwCounters._twitter_sentiment.find(item => { return item._sentiment === 0 })
          negativeSentiment = this.wiwCounters._twitter_sentiment.find(item => { return item._sentiment === -1 })
          generalSentiment = 'positive'
          if (positiveSentiment) {
            if (neutralSentiment && neutralSentiment._tweet_count > positiveSentiment._tweet_count) {
              generalSentiment = 'neutral'
            }
            if (negativeSentiment && negativeSentiment._tweet_count > positiveSentiment._tweet_count) {
              if (neutralSentiment && neutralSentiment._tweet_count < negativeSentiment._tweet_count) {
                generalSentiment = 'negative'
              }
            }
          } else if (negativeSentiment) {
            generalSentiment = 'negative'
            if (neutralSentiment && neutralSentiment._tweet_count > negativeSentiment._tweet_count) {
              generalSentiment = 'neutral'
            }
          } else {
            generalSentiment = 'neutral'
          }
          counters = 'On this day, the #WhereInTheWorld campaign collected' + this.formatNumber(this.wiwCounters._tweet_count) + ' mentions, gathering ' + this.formatNumber(this.wiwCounters._impression_count) + ' impressions on Twitter with a general ' + generalSentiment + ' sentiment.'
          if (this.wiwCounters._twitter_countries.length > 0) {
            counters = counters + ' The main contributors were from ' + this.wiwCounters._twitter_countries[0]._country_name + '.'
          }
          this.slide.addText(counters, {bullet: {code: '25CF'}, bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 0.8, y: this.slideLines, w: 7.85, isTextBox: true, autoFit: true, valign: 'top'})

          this.slideLines = this.slideLines + 0.3 + (0.2 * Math.floor(counters.length / 81))
          this.checkSlideLines()

          if (positiveSentiment || neutralSentiment || negativeSentiment) {
            this.slide.addText('Sentiment:', {bullet: {code: '25CF'}, bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 0.8, y: this.slideLines, w: 7.85, isTextBox: true, autoFit: true, valign: 'top'})
            this.slideLines = this.slideLines + 0.3
            this.checkSlideLines()

            if (positiveSentiment) {
              this.slide.addText('Positive: ' + this.formatNumber(positiveSentiment._tweet_count + ' Tweets'), {bullet: false, bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 1.2, y: this.slideLines, w: 7.85, isTextBox: true, autoFit: true, valign: 'top'})
              this.slideLines = this.slideLines + 0.3
              this.checkSlideLines()
            }

            if (neutralSentiment) {
              this.slide.addText('Neutral: ' + this.formatNumber(neutralSentiment._tweet_count + ' Tweets'), {bullet: false, bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 1.2, y: this.slideLines, w: 7.85, isTextBox: true, autoFit: true, valign: 'top'})
              this.slideLines = this.slideLines + 0.3
              this.checkSlideLines()
            }

            if (negativeSentiment) {
              this.slide.addText('Negative: ' + this.formatNumber(negativeSentiment._tweet_count + ' Tweets'), {bullet: false, bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 1.2, y: this.slideLines, w: 7.85, isTextBox: true, autoFit: true, valign: 'top'})
              this.slideLines = this.slideLines + 0.3
              this.checkSlideLines()
            }
          }
        }

        if (this.wiwTweets) {
          this.slide.addText('#WhereInTheWorld Top Tweets:', {bullet: {code: '25CF'}, bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 0.8, y: this.slideLines, w: 7.85, isTextBox: true, autoFit: true, valign: 'top'})
          this.slideLines = this.slideLines + 0.3
          this.checkSlideLines()
          for (t = 0; t < this.wiwTweets.length; t++) {
            tweet = this.wiwTweets[t]
            while (tweet._text.indexOf('\n') !== -1) {
              tweet._text = tweet._text.replace('\n', ' ')
            }
            this.slide.addText(tweet._text, {bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 1.42, y: this.slideLines, w: 7.1, isTextBox: true, autoFit: true, valign: 'top', bullet: {code: '25CF'}})
            this.slideLines = this.slideLines + 0.3 + (0.2 * Math.floor(this.wiwTweets[t]._text.length / 81))
            this.checkSlideLines()
            tweetInfo = '- ' + this.formatNumber(tweet._retweet_count_latest) + ' Retweets  - ' + this.formatNumber(tweet._favorite_count_latest) + ' Favorites  - ' + 'Created at: ' + tweet._created_at + '  - User: @' + tweet._user_name + '  - ' + this.formatNumber(tweet._user_followers_count) + ' Followers'
            this.slide.addText(tweetInfo, {bullet: false, bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 1.8, y: this.slideLines, w: 6.6, isTextBox: true, autoFit: true, valign: 'top'})
            this.slideLines = this.slideLines + 0.3 + (0.2 * Math.floor(tweetInfo.length / 81))
            this.checkSlideLines()
            this.slide.addText(
              [{
                text: 'Tweet',
                options: { hyperlink: { url: 'https://twitter.com/' + tweet._user_name + '/status/' + tweet._twitter_id, tooltip: 'Go to tweet' } }
              }],
              {
                bullet: false, bold: true, fontSize: 12, color: '3A3AB9', fontFace: 'Proxima Nova', lineSpacing: 15, x: 0.8, y: this.slideLines, w: 6.6, isTextBox: true, autoFit: true, valign: 'top'
              }
            )
            this.slideLines = this.slideLines + 0.6
            this.checkSlideLines()
          }
        }

        if (this.wiwTwitterStats.length > 0) {
          for (ts = 0; ts < this.wiwTwitterStats.length; ts++) {
            this.slide.addText(this.wiwTwitterStats[ts]._tweet_type + ': ' + this.formatNumber(this.wiwTwitterStats[ts]._tweet_count), {bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 1.42, y: this.slideLines, w: 7.1, isTextBox: true, autoFit: true, valign: 'top', bullet: {code: '25CF'}})
            this.slideLines = this.slideLines + 0.6
            this.checkSlideLines()
          }
        }
      }

      var dateRangeSave = this.months[fromMonth] + '_' + from
      if (fromMonth !== toMonth) {
        dateRangeSave = dateRangeSave + '_' + this.months[toMonth] + '_' + to
      } else if (from !== to) {
        dateRangeSave = dateRangeSave + '_' + to
      }

      this.pptx.save('Amaala_Daily_Digest_' + dateRangeSave)
      this.exportLoading = false
    },
    addStoriesToPptx (dataArray, selectionArray) {
      var stories = this[dataArray]
      var selection = this[selectionArray]
      for (var i = 0; i < stories.length; i++) {
        this.slide.addText(selection[i], {bullet: {code: '25CF'}, bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 0.8, y: this.slideLines, w: 7.85, isTextBox: true, autoFit: true, valign: 'top'})
        this.slideLines = this.slideLines + 0.3 + (0.2 * Math.floor(selection[i].length / 95))
        this.checkSlideLines()
        let sourceNames = ''
        let sourcesArray = []
        let note = '- Story: ' + selection[i] + '\n' + '- Articles:'
        for (var k in stories[i].articles) {
          var article = stories[i].articles[k]
          if (!sourcesArray.includes(this.sld(article.domain))) {
            sourcesArray.push(this.sld(article.domain))
            sourceNames = sourceNames + this.capitalizeWord(this.sld(article.domain))
            if (k < stories[i].articles.length - 1) {
              sourceNames += ', '
            }
          }
          note = note + '\n       - ' + article.url
        }
        note = note + '\n\n'
        this.slide.addText(sourceNames, {x: 1.17, y: this.slideLines, fontSize: 10, color: '3A3AB9', fontFace: 'Proxima Nova', bullet: false, autoFit: true, valign: 'top'})
        this.slide.addNotes(note)
        this.slideLines = this.slideLines + 0.3
        this.checkSlideLines()
      }
    },
    addArticlesToPptx (dataArray, selectionArray) {
      var articles = this[dataArray]
      var selection = this[selectionArray]
      for (var i = 0; i < articles.length; i++) {
        this.slide.addText(selection[i], {bullet: {code: '25CF'}, bold: true, fontSize: 12, color: '006A56', fontFace: 'Proxima Nova', lineSpacing: 15, x: 0.8, y: this.slideLines, w: 7.85, isTextBox: true, autoFit: true, valign: 'top'})
        this.slideLines = this.slideLines + 0.3 + (0.2 * Math.floor(selection[i].length / 95))
        this.checkSlideLines()
        this.slide.addText(this.capitalizeWord(this.sld(articles[i]._domain)), {x: 1.17, y: this.slideLines, fontSize: 10, color: '3A3AB9', fontFace: 'Proxima Nova', bullet: false, autoFit: true, valign: 'top'})
        this.slide.addText(
          [{
            text: this.sld(articles[i]._domain),
            options: { hyperlink: { url: articles[i]._url, tooltip: 'View article' } }
          }],
          { x: 1.17, y: this.slideLines, fontSize: 10, color: '3A3AB9', fontFace: 'Proxima Nova', bullet: false, autoFit: true, valign: 'top' }
        )
        this.slideLines = this.slideLines + 0.3
        this.checkSlideLines()
      }
    },
    capitalizeWord (word) {
      return word[0].toUpperCase() + word.slice(1, word.length)
    },
    checkSlideLines () {
      if (this.slideLines > 12.5) {
        this.slide = this.pptx.addNewSlide(this.currentMaster)
        this.slideLines = 1.33
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/customReports/AmaalaDailyDigest.vue